// import { useState, useEffect, useRef, useCallback } from "react";
// import { useParams, useSearchParams, useNavigate, useLocation } from "react-router-dom";
// import AgoraRTC from "agora-rtc-sdk-ng";
// import AgoraRTM from "agora-rtm-sdk";


// // ─────────────────────────────────────────────────────────────────────────────
// // URL structure: /live/:channel_name?role=host|audience&name=DisplayName
// //
// // Architecture:
// //   - HOST: publishes camera + mic, can screen share, can record
// //   - AUDIENCE: subscribe-only, no tracks, no controls
// //   - Recording: uploads to S3 via backend API (no local download)
// //   - Chat removed entirely
// // ─────────────────────────────────────────────────────────────────────────────

// const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

// /* ─────────────────────────────────────────────────────────────────────────
//    ICONS
// ───────────────────────────────────────────────────────────────────────── */
// const Icon = ({ d, size = 20, stroke = "currentColor", fill = "none", strokeWidth = 1.6 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}
//     stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
//     <path d={d} />
//   </svg>
// );
// const icons = {
//   mic: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8",
//   micOff: "M1 1l22 22M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23M12 19v4M8 23h8",
//   video: "M23 7l-7 5 7 5V7zM1 5h15a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H1a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
//   videoOff: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22",
//   screen: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3",

//   screenOff: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3M1 1l22 22",
//   users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
//   leave: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
//   recStop: "M18 6H6v12h12V6z",
//   record: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z",
//   upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
//   wifi: "M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01",
//   eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 12m-3 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0",
//   close: "M18 6L6 18M6 6l12 12",
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    GLOBAL CSS
// ───────────────────────────────────────────────────────────────────────── */
// const GlobalStyle = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=Space+Mono:wght@400;700&display=swap');
//     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
//     :root {
//       --bg-void:#050507; --bg-deep:#0b0c10; --bg-surface:#111318; --bg-raised:#191c22; --bg-overlay:#1f232b;
//       --border-dim:rgba(255,255,255,0.05); --border-soft:rgba(255,255,255,0.09); --border-bright:rgba(255,255,255,0.22);
//       --text-primary:#f0f2f8; --text-secondary:#8a909e; --text-muted:#535868;
//       --accent-cyan:#00d4ff; --accent-green:#00e676; --accent-red:#ff3d57; --accent-purple:#b47dff;
//       --glow-cyan:0 0 20px rgba(0,212,255,0.25),0 0 60px rgba(0,212,255,0.08);
//       --glow-red:0 0 20px rgba(255,61,87,0.35),0 0 60px rgba(255,61,87,0.1);
//       --font-ui:'DM Sans',sans-serif; --font-mono:'Space Mono',monospace;
//       --ease-spring:cubic-bezier(0.34,1.56,0.64,1); --ease-smooth:cubic-bezier(0.4,0,0.2,1);
//     }
//     html,body,#root { width:100%; height:100%; overflow:hidden; }
//     body { font-family:var(--font-ui); background:var(--bg-void); color:var(--text-primary); -webkit-font-smoothing:antialiased; }
//     ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-track{background:transparent} ::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.14);border-radius:4px}
//     @keyframes fadeUp     { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
//     @keyframes pulse-ring { 0%{transform:scale(1);opacity:.7} 100%{transform:scale(1.55);opacity:0} }
//     @keyframes rec-blink  { 0%,100%{opacity:1} 50%{opacity:.3} }
//     @keyframes shimmer    { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
//     @keyframes slide-right{ from{opacity:0;transform:translateX(20px)} to{opacity:1;transform:translateX(0)} }
//     @keyframes rec-pulse  { 0%,100%{box-shadow:0 0 0 0 rgba(255,61,87,.4)} 50%{box-shadow:0 0 0 8px rgba(255,61,87,0)} }
//     @keyframes fadeIn     { from{opacity:0} to{opacity:1} }
//     .shimmer-bar { height:2px; background:linear-gradient(90deg,transparent 0%,var(--accent-cyan) 50%,transparent 100%); background-size:200% 100%; animation:shimmer 2s linear infinite; opacity:.5; }
//     .ctrl-btn { position:relative; width:50px; height:50px; border-radius:50%; border:1.5px solid var(--border-soft); background:var(--bg-raised); color:var(--text-secondary); cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .22s var(--ease-smooth); outline:none; flex-shrink:0; }
//     .ctrl-btn:hover  { background:var(--bg-overlay); border-color:var(--border-bright); color:var(--text-primary); transform:translateY(-2px); }
//     .ctrl-btn:active { transform:scale(.93) translateY(0); }
//     .ctrl-btn.is-on    { background:rgba(0,212,255,.12); border-color:rgba(0,212,255,.4); color:var(--accent-cyan); box-shadow:0 0 14px rgba(0,212,255,.18); }
//     .ctrl-btn.is-off   { background:rgba(255,61,87,.12); border-color:rgba(255,61,87,.4); color:var(--accent-red); }
//     .ctrl-btn.is-rec   { background:rgba(255,61,87,.2); border-color:rgba(255,61,87,.6); color:var(--accent-red); animation:rec-pulse 2s ease-in-out infinite; }
//     .ctrl-btn.is-leave { width:56px; height:56px; background:var(--accent-red); border-color:var(--accent-red); color:#fff; }
//     .ctrl-btn.is-leave:hover { background:#ff5569; box-shadow:var(--glow-red); transform:translateY(-2px) scale(1.05); }
//     .ctrl-btn:disabled { opacity:.35; cursor:not-allowed; transform:none !important; }
//     .ctrl-tip { position:absolute; bottom:calc(100% + 10px); left:50%; transform:translateX(-50%); background:var(--bg-overlay); border:1px solid var(--border-soft); color:var(--text-primary); font-size:11px; font-family:var(--font-ui); padding:5px 10px; border-radius:6px; white-space:nowrap; opacity:0; pointer-events:none; transition:opacity .15s; }
//     .ctrl-btn:hover .ctrl-tip { opacity:1; }
//     .p-card { display:flex; align-items:center; gap:12px; padding:10px 14px; border-radius:14px; border:1px solid var(--border-dim); background:var(--bg-raised); transition:all .2s; cursor:default; animation:fadeUp .35s both; }
//     .p-card:hover { background:var(--bg-overlay); border-color:var(--border-soft); }
//     .vid-tile { position:relative; border-radius:16px; overflow:hidden; background:#0b0c10; border:1.5px solid var(--border-soft); width:100%; height:100%; animation:fadeIn .3s both; }
//     .vid-tile.local { border-color:rgba(0,212,255,.3); }
//     .vid-tile.screen { border-color:rgba(180,125,255,.4); }
//     .name-tag { position:absolute; bottom:16px; left:16px; display:flex; align-items:center; gap:6px; background:rgba(5,5,7,.8); backdrop-filter:blur(12px); border:1px solid rgba(255,255,255,.08); padding:6px 12px 6px 10px; border-radius:24px; font-size:13px; font-weight:500; color:var(--text-primary); }
//     .muted-badge { position:absolute; top:12px; right:12px; background:rgba(255,61,87,.2); border:1px solid rgba(255,61,87,.4); border-radius:50%; width:30px; height:30px; display:flex; align-items:center; justify-content:center; }
//     .rec-dot { width:8px; height:8px; border-radius:50%; background:var(--accent-red); animation:rec-blink 1.2s ease-in-out infinite; flex-shrink:0; }
//     .slide-right { animation:slide-right .28s var(--ease-spring) both; }
//     .upload-toast { position:fixed; bottom:100px; left:50%; transform:translateX(-50%); background:rgba(0,212,255,.12); border:1px solid rgba(0,212,255,.3); color:var(--accent-cyan); font-family:var(--font-ui); font-size:13px; font-weight:500; padding:10px 20px; border-radius:24px; display:flex; align-items:center; gap:8px; backdrop-filter:blur(12px); z-index:999; animation:fadeUp .4s var(--ease-spring) both; white-space:nowrap; }
//     .audience-banner { position:absolute; bottom:16px; left:50%; transform:translateX(-50%); background:rgba(180,125,255,.12); border:1px solid rgba(180,125,255,.3); color:var(--accent-purple); font-size:12px; font-weight:500; padding:6px 16px; border-radius:20px; display:flex; align-items:center; gap:6px; white-space:nowrap; pointer-events:none; }
//   `}</style>
// );

// /* ─────────────────────────────────────────────────────────────────────────
//    AVATAR
// ───────────────────────────────────────────────────────────────────────── */
// const AV_COLORS = ["#00d4ff", "#00e676", "#b47dff", "#ffab00", "#ff6b6b", "#00bcd4", "#69f0ae", "#ea80fc"];
// const Avatar = ({ uid, size = 36, name }) => {
//   const color = AV_COLORS[(Number(uid) || 0) % AV_COLORS.length];
//   const initials = name ? name.slice(0, 2).toUpperCase() : String(uid || "?").slice(-2);
//   return (
//     <div style={{ width: size, height: size, borderRadius: "50%", background: `${color}22`, border: `1.5px solid ${color}55`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color, fontFamily: "var(--font-mono)", flexShrink: 0 }}>
//       {initials}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    CTRL BUTTON
// ───────────────────────────────────────────────────────────────────────── */
// const CtrlBtn = ({ iconPath, tooltip, onClick, cls = "", size = 20, disabled = false }) => (
//   <button className={`ctrl-btn ${cls}`} onClick={onClick} disabled={disabled}>
//     <Icon d={iconPath} size={size} />
//     <span className="ctrl-tip">{tooltip}</span>
//   </button>
// );


// /* ─────────────────────────────────────────────────────────────────────────
//    HOST VIDEO TILE — full-screen, single source of truth
//    Shows screen share when active, otherwise camera
// ───────────────────────────────────────────────────────────────────────── */
// const HostVideoTile = ({ videoTrack, screenTrack, screenOn, camOn, micOn }) => {

//   const location = useLocation();

//   const hostName = location.state?.hostName;
//   const cameraRef = useRef(null);
//   const screenRef = useRef(null);

//   // Play camera track
//   useEffect(() => {
//     if (!cameraRef.current || !videoTrack) return;
//     const t = setTimeout(() => { try { videoTrack.play(cameraRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [videoTrack]);

//   // Play screen track
//   useEffect(() => {
//     if (!screenRef.current || !screenTrack) return;
//     const t = setTimeout(() => { try { screenTrack.play(screenRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [screenTrack]);

//   return (
//     <div className={`vid-tile ${screenOn ? "screen" : "local"}`} style={{ background: "var(--bg-deep)" }}>
//       {/* Camera layer — hidden during screen share */}
//       <div ref={cameraRef}
//         style={{ width: "100%", height: "100%", display: screenOn ? "none" : (camOn && videoTrack ? "block" : "none") }} />

//       {/* Screen share layer */}
//       <div ref={screenRef}
//         style={{ width: "100%", height: "100%", display: screenOn && screenTrack ? "block" : "none" }} />

//       {/* No-video placeholder */}
//       {!screenOn && (!camOn || !videoTrack) && (
//         <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-deep)", flexDirection: "column", gap: 16 }}>
//           <Avatar uid={0} size={72} name={hostName} />
//           <span style={{ fontSize: 15, color: "var(--text-secondary)", fontWeight: 500 }}>{hostName}</span>
//         </div>
//       )}

//       {/* Name tag */}
//       <div className="name-tag">
//         <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
//         {screenOn ? `${hostName} · Screen Share` : hostName}
//         <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
//       </div>

//       {/* Muted badge */}
//       {!micOn && (
//         <div className="muted-badge">
//           <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    REMOTE HOST VIDEO TILE — audience sees this
// ───────────────────────────────────────────────────────────────────────── */
// const RemoteHostTile = ({ user }) => {
//   const location = useLocation();

//   const hostName = location.state?.hostName;
//   const videoRef = useRef(null);
  
//   const hasVideo = !!user.videoTrack;
//   const hasAudio = !!user.audioTrack;

//   // FIX: video subscribe — play into DOM container immediately after mount/track change.
//   // Agora requires the container to be in the DOM with real dimensions when play() is called.
//   // We use videoTrack as the dep so it re-runs when Agora fires user-published for "video".
//   useEffect(() => {
//     if (!videoRef.current || !user.videoTrack) return;

//     // FIX: video subscribe — small timeout lets React flush so the div is sized in the DOM
//     const t = setTimeout(() => {
//       try {
//         user.videoTrack.play(videoRef.current);
//       } catch (e) {
//         console.error("RemoteHostTile play error:", e);
//       }
//     }, 100);

//     return () => {
//       clearTimeout(t);
//       try { user.videoTrack.stop(); } catch (_) { }
//     };
//   }, [user.videoTrack]); // re-run every time the track object changes

//   return (
//     <div className="vid-tile" style={{ background: "var(--bg-deep)" }}>
//       {/* FIX: video subscribe — container must have explicit height so Agora can size the video element */}
//       <div
//         ref={videoRef}
//         style={{
//           width: "100%",
//           height: "100%",
//           minHeight: 400,
//           display: hasVideo ? "block" : "none",
//           // FIX: Agora injects a <video> inside; ensure it fills the container
//           overflow: "hidden",
//         }}
//       />
//       {!hasVideo && (
//         <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
//           <Avatar uid={user.uid} size={72} name={hostName || "Host"} />
//           <span style={{ fontSize: 15, color: "var(--text-secondary)" }}>{hostName || "Host"}</span>
//         </div>
//       )}
//       <div className="name-tag">
//         <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
//         {hostName || `Host ${String(user.uid).slice(-3)}`}
//         <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
//       </div>
//       {!hasAudio && (
//         <div className="muted-badge">
//           <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    PARTICIPANT CARD
// ───────────────────────────────────────────────────────────────────────── */
// const PCard = ({ uid, name, role, videoOn, audioOn }) => (
//   <div className="p-card">
//     <Avatar uid={uid} size={38} name={name} />
//     <div style={{ flex: 1, minWidth: 0 }}>
//       <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)", display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
//         {role === "host" && (
//           <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: 1, background: "rgba(0,212,255,.15)", color: "var(--accent-cyan)", border: "1px solid rgba(0,212,255,.3)", padding: "2px 6px", borderRadius: 4, flexShrink: 0 }}>HOST</span>
//         )}
//       </div>
//       <div style={{ marginTop: 3, display: "flex", gap: 8 }}>
//         <span style={{ fontSize: 11, color: audioOn ? "var(--accent-green)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//           <Icon d={audioOn ? icons.mic : icons.micOff} size={11} /> {audioOn ? "Live" : "Muted"}
//         </span>
//         {role === "host" && (
//           <span style={{ fontSize: 11, color: videoOn ? "var(--accent-cyan)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//             <Icon d={videoOn ? icons.video : icons.videoOff} size={11} /> {videoOn ? "Video" : "Off"}
//           </span>
//         )}
//         {role !== "host" && (
//           <span style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//             <Icon d={icons.eye} size={11} /> Watching
//           </span>
//         )}
//       </div>
//     </div>
//   </div>
// );

// /* ═════════════════════════════════════════════════════════════════════════
//    UPLOAD RECORDING TO S3 via backend
//    Expects backend endpoint: POST /upload-recording/
//    with multipart/form-data: { file, channel, uid }
// ═════════════════════════════════════════════════════════════════════════ */
// // const uploadRecordingToS3 = async ({ chunks, channelName, uid, onProgress }) => {
// //   if (!chunks || chunks.length === 0) return { ok: false, error: "No recording data" };

// //   const blob = new Blob(chunks, { type: "video/webm" });
// //   const filename = `recording-${channelName}-${uid}-${Date.now()}.webm`;
// //   const formData = new FormData();
// //   formData.append("file", blob, filename);
// //   formData.append("channel", channelName);
// //   formData.append("uid", String(uid));

// //   try {
// //     onProgress?.("uploading");
// //     const res = await fetch(`${API_URL}/upload-recording/`, {
// //       method: "POST",
// //       body: formData,
// //     });
// //     if (!res.ok) {
// //       const text = await res.text();
// //       throw new Error(`Upload failed: HTTP ${res.status} — ${text}`);
// //     }
// //     const data = await res.json();
// //     onProgress?.("done");
// //     return { ok: true, url: data.url || data.s3_url || null };
// //   } catch (err) {
// //     console.error("S3 upload error:", err);
// //     onProgress?.("error");
// //     return { ok: false, error: err.message };
// //   }
// // };
// const uploadRecordingToS3 = async ({
//   chunks,
//   postId,        // ✅ ADD THIS
//   channelName,
//   uid,
//   onProgress,
// }) => {
//   if (!chunks || chunks.length === 0) {
//     return { ok: false, error: "No recording data" };
//   }

//   const blob = new Blob(chunks, { type: "video/webm" });
//   const filename = `recording-${channelName}-${uid}-${Date.now()}.webm`;

//   const formData = new FormData();
//   formData.append("file", blob, filename);

//   // ✅ VERY IMPORTANT: send post_id
//   formData.append("post_id", postId);

//   try {
//     onProgress?.("uploading");

//     const res = await fetch(`${API_URL}/upload-recording/`, {
//       method: "POST",
//       body: formData,
//     });

//     if (!res.ok) {
//       const text = await res.text();
//       throw new Error(`Upload failed: HTTP ${res.status} — ${text}`);
//     }

//     const data = await res.json();

//     console.log("UPLOAD SUCCESS:", data); // ✅ debug

//     onProgress?.("done");

//     return {
//       ok: true,
//       url: data.url || null, // backend returns this
//     };

//   } catch (err) {
//     console.error("S3 upload error:", err);
//     onProgress?.("error");

//     return {
//       ok: false,
//       error: err.message,
//     };
//   }
// };

// /* ═════════════════════════════════════════════════════════════════════════
//    MAIN — LiveSession
// ═════════════════════════════════════════════════════════════════════════ */
// const LiveSession = () => {
//   const { id: channelName } = useParams();
//   const [searchParams] = useSearchParams();
//   const location = useLocation();
//   const postId = searchParams.get("post_id");
//   const streamRef = useRef(null); // single MediaStream, lives for full session
//   const hostName = location.state?.hostName;
//   const navigate = useNavigate();

//   // CHANGED: read display name from query param
//   const role = searchParams.get("role") === "audience" ? "audience" : "host";
//   const displayName = searchParams.get("name") || (role === "host" ? "Host" : "Viewer");
//   const isHost = role === "host";

//   /* ── Session state ── */
//   const [appInfo, setAppInfo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState("Initializing…");

//   /* ── Host media controls ── */
//   const [micOn, setMicOn] = useState(true);
//   const [camOn, setCamOn] = useState(true);
//   const [screenOn, setScreenOn] = useState(false);

//   /* ── Recording state ── */
//   const [recording, setRecording] = useState(false);
//   const [recSeconds, setRecSeconds] = useState(0);
//   const [uploadState, setUploadState] = useState(null); // null | 'uploading' | 'done' | 'error'

//   /* ── Tracks ── */
//   const [localAudio, setLocalAudio] = useState(null);
//   const [localVideo, setLocalVideo] = useState(null);
//   const [screenTrack, setScreenTrack] = useState(null);

//   // CHANGED: remoteUsers now only tracks the HOST from audience perspective
//   // From host perspective we track audience count only (no video)
//   const [remoteUsers, setRemoteUsers] = useState([]);

//   // CHANGED: separate participants map { uid -> { name, role } }
//   // We use RTM presence to sync names
//   const [participants, setParticipants] = useState({});
//   const [attendanceId, setAttendanceId] = useState(null);

//   /* ── UI ── */
//   const [panelOpen, setPanelOpen] = useState(true);

//   /* ── Refs ── */
//   const rtcClientRef = useRef(null);
//   const rtmClientRef = useRef(null);
//   const initialized = useRef(false);
//   const mrRef = useRef(null);
//   const chunksRef = useRef([]);
//   const recTimerRef = useRef(null);
//   const appInfoRef = useRef(null); // keep latest appInfo accessible in cleanup
//   const localAudioRef = useRef(null);
//   const localVideoRef = useRef(null);
//   const screenTrackRef = useRef(null);

//   // Mirror state into refs so async cleanup can access latest values
//   useEffect(() => { appInfoRef.current = appInfo; }, [appInfo]);
//   useEffect(() => { localAudioRef.current = localAudio; }, [localAudio]);
//   useEffect(() => { localVideoRef.current = localVideo; }, [localVideo]);
//   useEffect(() => { screenTrackRef.current = screenTrack; }, [screenTrack]);

//   const fmtTime = (sec) => {
//   const m = Math.floor(sec / 60);
//   const s = sec % 60;
//   return `${m}:${s.toString().padStart(2, "0")}`;
// };

//   /* ─────────────────────────────────────────────────────────────────
//      TOKEN FETCH
//   ───────────────────────────────────────────────────────────────── */
//   const initSession = useCallback(async () => {
//     if (initialized.current) return;
//     initialized.current = true;
//     try {
//       setStatus("Fetching token…");
//       const uid = Math.floor(Math.random() * 9000) + 1000;
//       const res = await fetch(
//         `${API_URL}/agora-token/?channel=${channelName}&uid=${uid}&role=${role}&name=${encodeURIComponent(displayName)}`
//       );
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       if (!data.token || !data.appId) throw new Error("Missing token/appId");
//       setAppInfo({ appId: data.appId, token: data.token, uid, channel: channelName });
//       setStatus("Joining channel…");
//     } catch (err) {
//       setStatus(`Error: ${err.message}`);
//       setLoading(false);
//     }
//   }, [channelName, role, displayName]);

//   useEffect(() => {
//     if (channelName && !initialized.current) initSession();
//   }, [channelName, initSession]);

//   /* ─────────────────────────────────────────────────────────────────
//      JOIN — RTC + RTM
//   ───────────────────────────────────────────────────────────────── */
//   useEffect(() => {
//     if (!appInfo) return;
//     let isMounted = true;

//     const join = async () => {
//       try {
//         /* ── RTC ── */
//         const rtc = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
//         rtcClientRef.current = rtc;
//         await rtc.setClientRole(isHost ? "host" : "audience");

//         // CHANGED: audience should not see other audience users in video grid
//         // Track remote users; host sees nothing from audience (they have no tracks)
//         // FIX: audience subscribes to ALL remote users (the host is a remote user from audience POV)
//         // FIX: video subscribe — handle audio and video mediaType separately and play video immediately
//         rtc.on("user-published", async (user, mediaType) => {
//           // FIX: audience no publish — host skips subscribing to remote video (audience has no tracks anyway)
//           if (isHost) return;

//           await rtc.subscribe(user, mediaType);

//           // FIX: video subscribe — play audio track inline; store video track for rendering
//           if (mediaType === "audio" && user.audioTrack) {
//             user.audioTrack.play();
//           }

//           if (!isMounted) return;

//           // FIX: host detection via user-published event
//           // setParticipants(prev => ({
//           //   ...prev,
//           //   [user.uid]: {
//           //     uid: user.uid,
//           //     name: prev[user.uid]?.name || `Host`,
//           //     role: "host", // anyone who publishes in a live stream = host
//           //   },
//           // }));
//           // FIX: use real host name instead of "Host"
//           setParticipants(prev => ({
//             ...prev,
//             [user.uid]: {
//               uid: user.uid,
//               name: hostName || "Host",   // ✅ real name here
//               role: "host",
//             },
//           }));

//           setRemoteUsers(prev => {
//             const exists = prev.find(u => u.uid === user.uid);
//             const updated = {
//               uid: user.uid,
//               audioTrack: mediaType === "audio" ? user.audioTrack : (exists?.audioTrack ?? null),
//               // FIX: video subscribe — capture the videoTrack object so RemoteHostTile can play it
//               videoTrack: mediaType === "video" ? user.videoTrack : (exists?.videoTrack ?? null),
//             };
//             return exists ? prev.map(u => u.uid === user.uid ? updated : u) : [...prev, updated];
//           });
//         });

//         rtc.on("user-unpublished", (user, mediaType) => {
//           if (isHost) return;
//           setRemoteUsers(prev => prev.map(u =>
//             u.uid !== user.uid ? u : {
//               ...u,
//               audioTrack: mediaType === "audio" ? null : u.audioTrack,
//               videoTrack: mediaType === "video" ? null : u.videoTrack,
//             }
//           ));
//         });

//         // CHANGED: track all joined users for participant list
//         rtc.on("user-joined", (user) => {
//           if (!isMounted) return;
//           setParticipants(prev => ({ ...prev, [user.uid]: { uid: user.uid, name: user.uid === appInfo.uid ? hostName || "Host" : "Audience", role: "audience" } }));
//           if (!isHost) {
//             setRemoteUsers(prev => prev.find(u => u.uid === user.uid) ? prev : [...prev, { uid: user.uid, audioTrack: null, videoTrack: null }]);
//           }
//         });

//         rtc.on("user-left", (user) => {
//           if (!isMounted) return;
//           setParticipants(prev => { const n = { ...prev }; delete n[user.uid]; return n; });
//           setRemoteUsers(prev => prev.filter(u => u.uid !== user.uid));
//         });

//         await rtc.join(appInfo.appId, appInfo.channel, appInfo.token, appInfo.uid);

//         /* ── Host publishes tracks only ── */
//         if (isHost) {
//           const [audio, video] = await AgoraRTC.createMicrophoneAndCameraTracks(
//             { encoderConfig: "music_standard" },
//             { encoderConfig: { width: 1280, height: 720, frameRate: 30, bitrateMin: 600, bitrateMax: 2000 } }
//           );
//           if (!isMounted) { audio.stop(); audio.close(); video.stop(); video.close(); return; }
//           await rtc.publish([audio, video]);
//           setLocalAudio(audio);
//           setLocalVideo(video);
//         }

//         /* ── RTM — for name sync & presence ── */
//         setStatus("Connecting to presence…");

//         // FIX: RTM constructor — agora-rtm-sdk v2 exports the class as default.
//         // { RTM } destructuring fails ("RTM is not a constructor").
//         // Support both SDK shapes: v2 default export OR v1 named export.
//         const RTMClass = AgoraRTM.RTM || AgoraRTM.default?.RTM || AgoraRTM;
//         const rtm = new RTMClass(appInfo.appId, String(appInfo.uid));
//         rtmClientRef.current = rtm;

//         await rtm.login({ token: appInfo.token });

//         // FIX: subscribe before trying to publish or setState
//         try {
//           await rtm.subscribe(appInfo.channel, { withPresence: true, withMessage: true });
//         } catch (subErr) {
//           console.warn("RTM subscribe:", subErr);
//         }

//         // FIX: listen for NAME_SYNC messages (fallback name broadcast)
//         rtm.addEventListener("message", (event) => {
//           if (!isMounted) return;
//           try {
//             const p = JSON.parse(event.message);
//             if (p.type === "NAME_SYNC" && p.uid && p.name) {
//               setParticipants(prev => ({
//                 ...prev,
//                 [p.uid]: { uid: p.uid, name: p.name, role: p.role || "audience" },
//               }));
//             }
//           } catch (_) { }
//         });

//         // Announce our presence with name + role
//         // FIX: RTM presence setState signature differs between SDK versions — try both
//         try {
//           // RTM v2 presence setState
//           if (typeof rtm.presence?.setState === "function") {
//             await rtm.presence.setState(appInfo.channel, "MESSAGE_CHANNEL", {
//               name: displayName,
//               role: role,
//             });
//           }
//         } catch (presenceErr) {
//           console.warn("RTM presence.setState:", presenceErr);
//         }

//         // FIX: also broadcast via channel message so other clients get our name immediately
//         // This is a fallback that works across all RTM SDK versions
//         try {
//           const nameMsg = JSON.stringify({ type: "NAME_SYNC", uid: appInfo.uid, name: displayName, role });
//           await rtm.publish(appInfo.channel, nameMsg);
//         } catch (_) { /* non-critical */ }

//         // Listen for presence updates to build name map
//         rtm.addEventListener("presence", (event) => {
//           if (!isMounted) return;
//           const states = event.stateChanged || {};
//           const uid = event.publisher;
//           if (uid && states.name) {
//             setParticipants(prev => ({
//               ...prev,
//               [uid]: { uid, name: states.name, role: states.role || "audience" },
//             }));
//           }
//         });

//         // CHANGED: add ourselves to participants
//         if (isMounted) {
//           setParticipants(prev => ({
//             ...prev,
//             [appInfo.uid]: { uid: appInfo.uid, name: displayName, role },
//           }));
//         }

//         if (!isMounted) return;
//         setStatus(`Live · ${channelName}`);
//         setLoading(false);
//         // ✅ MARK JOIN
// //         try {
// //           const res = await fetch(`${API_URL}/mark-join/`, { ... });
// // if (!res.ok) {
// //   const err = await res.json().catch(() => ({}));
// //   console.error("mark-join failed:", res.status, err);
// //   return; // stop here — attendance_id stays null
// // }
// // const data = await res.json();
// // setAttendanceId(data.attendance_id);
// //         } catch (err) {
// //           console.error("Attendance join error:", err);
// //         }

//       } catch (err) {
//         console.error("Join error:", err);
//         if (isMounted) {
//           setStatus(`Join failed: ${err.message}`);
//           setLoading(false);
//         }
//       }
//     };

//     join();

//     return () => {
//       isMounted = false;
//       // Cleanup handled by handleLeave / doLeave
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [appInfo]);

//   /* ─────────────────────────────────────────────────────────────────
//      FIX: auto recording — host only, once, after loading completes
//   ───────────────────────────────────────────────────────────────── */

//    const autoRecStarted = useRef(false);
//   useEffect(() => {
//     if (loading || !isHost || autoRecStarted.current) return;
//     autoRecStarted.current = true;
//     // Delay so the UI is fully rendered before browser prompts for screen share
//     const t = setTimeout(() => { startRecording(); }, 1500);
//     return () => clearTimeout(t);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, isHost]);
// const startRecording = useCallback(() => {
//   if (mrRef.current) return;

//   try {
//     const stream = new MediaStream();

//     // Video: camera to start
//     const videoSource = localVideoRef.current;
//     if (videoSource?.getMediaStreamTrack) {
//       stream.addTrack(videoSource.getMediaStreamTrack());
//     }

//     // Audio: always present, never swapped
//     if (localAudioRef.current?.getMediaStreamTrack) {
//       stream.addTrack(localAudioRef.current.getMediaStreamTrack());
//     }

//     if (stream.getTracks().length === 0) {
//       console.warn("[Recording] No tracks available");
//       return;
//     }

//     streamRef.current = stream; // ✅ keep reference for track swapping

//     const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
//       ? "video/webm;codecs=vp9,opus"
//       : "video/webm";

//     chunksRef.current = [];
//     const mr = new MediaRecorder(stream, {
//       mimeType,
//       videoBitsPerSecond: 2_500_000,
//     });

//     mr.ondataavailable = (e) => {
//       if (e.data?.size > 0) chunksRef.current.push(e.data);
//     };

//     mr.onstop = async () => {
//       const chunks = [...chunksRef.current];
//       chunksRef.current = [];
//       if (chunks.length === 0) return;

//       setUploadState("uploading");
//       const result = await uploadRecordingToS3({
//         chunks,
//         channelName,
//         uid: appInfoRef.current?.uid,
//         postId,
//         onProgress: setUploadState,
//       });
//       if (!result.ok) {
//         setUploadState("error");
//         setTimeout(() => setUploadState(null), 5000);
//       } else {
//         setUploadState("done");
//         setTimeout(() => setUploadState(null), 4000);
//       }
//     };

//     mr.start(1000);
//     mrRef.current = mr;
//     setRecording(true);
//     setRecSeconds(0);
//     recTimerRef.current = setInterval(() => setRecSeconds(s => s + 1), 1000);
//     console.log("[Recording] Started — single stream, tracks:", stream.getTracks().length);

//   } catch (err) {
//     console.error("[Recording] Failed to start:", err);
//   }
// }, [channelName, postId]);
 
//   // const startRecording = async () => {
//   //   if (recording) return;
//   //   try {
//   //     const stream = await navigator.mediaDevices.getDisplayMedia({
//   //       video: { displaySurface: "browser" },
//   //       audio: true,
//   //       preferCurrentTab: true,
//   //     });

//   //     chunksRef.current = [];
//   //     const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
//   //       ? "video/webm;codecs=vp9,opus"
//   //       : "video/webm";
//   //     const mr = new MediaRecorder(stream, { mimeType });

//   //     mr.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };

//   //     // CHANGED: on stop → upload to S3, NOT download
//   //     mr.onstop = async () => {
//   //       stream.getTracks().forEach(t => t.stop());
//   //       const chunks = [...chunksRef.current];
//   //       chunksRef.current = [];
//   //       if (chunks.length === 0) return;

//   //       setUploadState("uploading");
//   //       const result = await uploadRecordingToS3({
//   //         chunks,
//   //         channelName,
//   //         uid: appInfoRef.current?.uid,
//   //         postId,// ✅ send postId for backend association
//   //         onProgress: setUploadState,
//   //       });
//   //       if (!result.ok) {
//   //         console.error("Upload failed:", result.error);
//   //         setUploadState("error");
//   //         // Reset error toast after 5s
//   //         setTimeout(() => setUploadState(null), 5000);
//   //       } else {
//   //         setUploadState("done");
//   //         setTimeout(() => setUploadState(null), 4000);
//   //       }
//   //     };

//   //     mr.start(1000);
//   //     mrRef.current = mr;
//   //     setRecording(true);
//   //     setRecSeconds(0);
//   //     recTimerRef.current = setInterval(() => setRecSeconds(s => s + 1), 1000);

//   //   } catch (err) {
//   //     if (err.name === "NotAllowedError") {
//   //       console.log("User denied screen recording, retrying...");

//   //       // 🔁 Retry after 3 seconds
//   //       setTimeout(() => {
//   //         if (!mrRef.current && !recording) {
//   //           startRecording();
//   //         }
//   //       }, 3000);
//   //     } else {
//   //       console.error("Recording error:", err);
//   //     }
//   //   }
//   // };

  


//   /* ─────────────────────────────────────────────────────────────────
//      LEAVE — full cleanup
//   ───────────────────────────────────────────────────────────────── */
//   const doLeave = useCallback(async () => {
//     // CHANGED: stop recording first → triggers S3 upload
//     // ✅ MARK LEAVE
//     try {
//       if (attendanceId) {
//         await fetch(`${API_URL}/mark-leave/`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`
//           },
//           body: JSON.stringify({
//             attendance_id: attendanceId
//           })
//         });
//       }
//     } catch (err) {
//       console.error("Attendance leave error:", err);
//     }
//     if (mrRef.current && mrRef.current.state !== "inactive") {
//       clearInterval(recTimerRef.current);
//       mrRef.current.stop();
//       mrRef.current = null;
//       setRecording(false);
//     }

//     // CHANGED: properly stop and close ALL tracks before leaving
//     try {
//       const audio = localAudioRef.current;
//       const video = localVideoRef.current;
//       const screen = screenTrackRef.current;

//       if (audio) { try { audio.stop(); audio.close(); } catch (_) { } }
//       if (video) { try { video.stop(); video.close(); } catch (_) { } }
//       if (screen) { try { screen.stop(); screen.close(); } catch (_) { } }

//       localAudioRef.current = null;
//       localVideoRef.current = null;
//       screenTrackRef.current = null;
//     } catch (_) { }

//     // Leave RTC
//     try {
//       if (rtcClientRef.current) {
//         await rtcClientRef.current.leave();
//         rtcClientRef.current = null;
//       }
//     } catch (_) { }

//     // Leave RTM
//     try {
//       if (rtmClientRef.current) {
//         await rtmClientRef.current.unsubscribe(appInfoRef.current?.channel);
//         await rtmClientRef.current.logout();
//         rtmClientRef.current = null;
//       }
//     } catch (_) { }

//     // CHANGED: reset all local state
//     setLocalAudio(null);
//     setLocalVideo(null);
//     setScreenTrack(null);
//     setRemoteUsers([]);
//     setParticipants({});
//   }, []);

//   const handleLeave = async () => {
//     await doLeave();
//     navigate(-1);
//   };

//   // CHANGED: cleanup on unmount
//   useEffect(() => {
//     return () => { doLeave(); };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /* ─────────────────────────────────────────────────────────────────
//      MIC / CAM / SCREEN — host only
//   ───────────────────────────────────────────────────────────────── */
//   const toggleMic = async () => {
//     if (!isHost || !localAudio) return;
//     const next = !micOn;
//     await localAudio.setMuted(!next);
//     setMicOn(next);
//   };

//   const toggleCam = async () => {
//     if (!isHost || !localVideo) return;
//     const next = !camOn;
//     await localVideo.setMuted(!next);
//     setCamOn(next);
//   };

//   // const toggleScreen = async () => {
//   //   if (!isHost || !rtcClientRef.current) return;

//   //   if (screenOn) {
//   //     // CHANGED: stop screen share → auto fallback to camera
//   //     try {
//   //       await rtcClientRef.current.unpublish(screenTrack);
//   //       screenTrack.stop();
//   //       screenTrack.close();
//   //       setScreenTrack(null);
//   //       if (localVideo) {
//   //         await rtcClientRef.current.publish(localVideo);
//   //       }
//   //     } catch (err) { console.error("Stop screen:", err); }
//   //     setScreenOn(false);

//   //   } else {
//   //     try {
//   //       const track = await AgoraRTC.createScreenVideoTrack(
//   //         { encoderConfig: "1080p_1", optimizationMode: "detail" },
//   //         "auto"
//   //       );
//   //       if (localVideo) await rtcClientRef.current.unpublish(localVideo);
//   //       await rtcClientRef.current.publish(track);

//   //       // CHANGED: handle browser-native screen share stop (user clicks "Stop sharing")
//   //       const handleTrackEnded = () => {
//   //         // Run async cleanup without awaiting in the event handler
//   //         (async () => {
//   //           try {
//   //             if (rtcClientRef.current) await rtcClientRef.current.unpublish(track);
//   //             track.stop();
//   //             track.close();
//   //             if (localVideoRef.current && rtcClientRef.current) {
//   //               await rtcClientRef.current.publish(localVideoRef.current);
//   //             }
//   //           } catch (_) { }
//   //           setScreenTrack(null);
//   //           setScreenOn(false);
//   //         })();
//   //       };
//   //       track.on("track-ended", handleTrackEnded);

//   //       setScreenTrack(track);
//   //       setScreenOn(true);
//   //     } catch (err) {
//   //       if (err.name !== "NotAllowedError") console.error("Screen share:", err);
//   //     }
//   //   }
//   // };

//   const toggleScreen = async () => {
//   if (!isHost || !rtcClientRef.current) return;

//   if (screenOn) {
//     try {
//       await rtcClientRef.current.unpublish(screenTrack);
//       screenTrack.stop();
//       screenTrack.close();
//       setScreenTrack(null);
//       if (localVideo) await rtcClientRef.current.publish(localVideo);

//       // ✅ Swap recording track: screen → camera (no stop/restart)
//       if (streamRef.current && localVideoRef.current?.getMediaStreamTrack) {
//         const oldVideo = streamRef.current.getVideoTracks()[0];
//         if (oldVideo) streamRef.current.removeTrack(oldVideo);
//         streamRef.current.addTrack(localVideoRef.current.getMediaStreamTrack());
//       }
//     } catch (err) { console.error("Stop screen:", err); }
//     setScreenOn(false);

//   } else {
//     try {
//       const track = await AgoraRTC.createScreenVideoTrack(
//         { encoderConfig: "1080p_1", optimizationMode: "detail" },
//         "auto"
//       );
//       if (localVideo) await rtcClientRef.current.unpublish(localVideo);
//       await rtcClientRef.current.publish(track);

//       // ✅ Swap recording track: camera → screen (no stop/restart)
//       if (streamRef.current && track?.getMediaStreamTrack) {
//         const oldVideo = streamRef.current.getVideoTracks()[0];
//         if (oldVideo) streamRef.current.removeTrack(oldVideo);
//         streamRef.current.addTrack(track.getMediaStreamTrack());
//       }

//       const handleTrackEnded = () => {
//         (async () => {
//           try {
//             if (rtcClientRef.current) await rtcClientRef.current.unpublish(track);
//             track.stop();
//             track.close();
//             if (localVideoRef.current && rtcClientRef.current) {
//               await rtcClientRef.current.publish(localVideoRef.current);
//             }
//           } catch (_) {}

//           // ✅ Swap back on browser "Stop sharing" too
//           if (streamRef.current && localVideoRef.current?.getMediaStreamTrack) {
//             const oldVideo = streamRef.current.getVideoTracks()[0];
//             if (oldVideo) streamRef.current.removeTrack(oldVideo);
//             streamRef.current.addTrack(localVideoRef.current.getMediaStreamTrack());
//           }

//           setScreenTrack(null);
//           setScreenOn(false);
//         })();
//       };
//       track.on("track-ended", handleTrackEnded);

//       setScreenTrack(track);
//       setScreenOn(true);
//     } catch (err) {
//       if (err.name !== "NotAllowedError") console.error("Screen share:", err);
//     }
//   }
// };

//   /* ─────────────────────────────────────────────────────────────────
//      DERIVED VALUES
//   ───────────────────────────────────────────────────────────────── */
//   const participantList = Object.values(participants);
//   const audienceCount = participantList.filter(p => p.role !== "host").length;

//   // FIX: host detection — in a live stream any remote user who publishes = host.
//   // Don't rely solely on RTM presence (slow). Take the first remote user with tracks,
//   // fallback to first remote user if no tracks yet (audio-only moment).
//   const remoteHostUser = !isHost
//     ? (remoteUsers.find(u => u.videoTrack || u.audioTrack) || remoteUsers[0] || null)
//     : null;

//   /* ─────────────────────────────────────────────────────────────────
//      LOADING SCREEN
//   ───────────────────────────────────────────────────────────────── */
//   if (loading) {
//     return (
//       <>
//         <GlobalStyle />
//         <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 32 }}>
//           <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20 }}>
//             <div style={{ width: 72, height: 72, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.3)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxShadow: "var(--glow-cyan)" }}>
//               <div style={{ position: "absolute", inset: 6, borderRadius: "50%", border: "1px solid rgba(0,212,255,.15)", animation: "pulse-ring 2s ease-out infinite" }} />
//               <Icon d={icons.video} size={28} stroke="var(--accent-cyan)" />
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <div style={{ fontSize: 22, fontWeight: 300, color: "var(--text-primary)", letterSpacing: "-0.5px" }}>Live Session</div>
//               <div style={{ fontSize: 13, color: "var(--accent-cyan)", marginTop: 4, fontFamily: "var(--font-mono)", letterSpacing: 2 }}>{channelName?.toUpperCase()}</div>
//             </div>
//           </div>
//           <div style={{ background: "var(--bg-surface)", border: "1px solid var(--border-soft)", borderRadius: "20px", padding: "24px 40px", display: "flex", flexDirection: "column", alignItems: "center", gap: 20, minWidth: 320 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--accent-cyan)", animation: "rec-blink 1.2s ease-in-out infinite" }} />
//               <span style={{ fontSize: 14, color: "var(--text-secondary)" }}>{status}</span>
//             </div>
//             <div style={{ width: "100%", height: 2, background: "var(--bg-overlay)", borderRadius: 2, overflow: "hidden" }}>
//               <div className="shimmer-bar" />
//             </div>
//             <div style={{ fontSize: 11, color: "var(--text-muted)", fontFamily: "var(--font-mono)", padding: "6px 14px", borderRadius: 6, background: "var(--bg-raised)", border: "1px solid var(--border-dim)", letterSpacing: 1 }}>
//               {isHost ? "HOST" : "AUDIENCE"} · {channelName?.toUpperCase()} · {displayName}
//             </div>
//             <button onClick={() => { initialized.current = false; setLoading(true); initSession(); }}
//               style={{ padding: "10px 28px", borderRadius: 24, background: "rgba(0,212,255,.1)", border: "1px solid rgba(0,212,255,.3)", color: "var(--accent-cyan)", fontFamily: "var(--font-ui)", fontSize: 14, fontWeight: 500, cursor: "pointer" }}>
//               Retry
//             </button>
//           </div>
//         </div>
//       </>
//     );
//   }

//   /* ─────────────────────────────────────────────────────────────────
//      MAIN UI
//   ───────────────────────────────────────────────────────────────── */
//   return (
//     <>
//       <GlobalStyle />
//       <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", flexDirection: "column", overflow: "hidden" }}>

//         {/* ══ TOP BAR ══════════════════════════════════════════════ */}
//         <header style={{ height: 58, display: "flex", alignItems: "center", padding: "0 20px", borderBottom: "1px solid var(--border-dim)", background: "rgba(5,5,7,.9)", backdropFilter: "blur(20px)", flexShrink: 0, zIndex: 100, gap: 16 }}>

//           <div style={{ display: "flex", alignItems: "center", gap: 14, flex: 1 }}>
//             <div style={{ width: 32, height: 32, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.35)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 12px rgba(0,212,255,.18)" }}>
//               <Icon d={icons.video} size={15} stroke="var(--accent-cyan)" />
//             </div>
//             <div>
//               {/* CHANGED: show channel name prominently */}
//               <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>{channelName}</div>
//               <div style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 5, marginTop: 1 }}>
//                 <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--accent-green)", display: "inline-block", boxShadow: "0 0 8px rgba(0,230,118,.6)" }} />
//                 Live
//                 {/* · {audienceCount} viewer{audienceCount !== 1 ? "s" : ""} */}
//               </div>
//             </div>
//           </div>

//           {/* CHANGED: show actual display name, not UID */}
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <Avatar uid={appInfo?.uid} size={28} name={displayName} />
//             <div>
//               <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text-primary)" }}>{displayName}</div>
//               <div style={{ fontSize: 10, color: isHost ? "var(--accent-cyan)" : "var(--accent-purple)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>{role.toUpperCase()}</div>
//             </div>
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, justifyContent: "flex-end" }}>
//             {recording && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(255,61,87,.1)", border: "1px solid rgba(255,61,87,.25)" }}>
//                 <div className="rec-dot" />
//                 <span style={{ fontSize: 11, color: "var(--accent-red)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>
//                   REC {fmtTime(recSeconds)}
//                 </span>
//               </div>
//             )}
//             {uploadState === "uploading" && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)" }}>
//                 <Icon d={icons.upload} size={12} stroke="var(--accent-cyan)" />
//                 <span style={{ fontSize: 11, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)" }}>UPLOADING</span>
//               </div>
//             )}
//             {screenOn && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(180,125,255,.1)", border: "1px solid rgba(180,125,255,.3)" }}>
//                 <Icon d={icons.screen} size={13} stroke="var(--accent-purple)" />
//                 <span style={{ fontSize: 11, color: "var(--accent-purple)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>SHARING</span>
//               </div>
//             )}
//           </div>
//         </header>

//         <div className="shimmer-bar" />

//         {/* Upload result toasts */}
//         {uploadState === "done" && (
//           <div className="upload-toast">
//             <Icon d={icons.upload} size={14} />
//             Recording uploaded successfully
//           </div>
//         )}
//         {uploadState === "error" && (
//           <div className="upload-toast" style={{ background: "rgba(255,61,87,.12)", borderColor: "rgba(255,61,87,.3)", color: "var(--accent-red)" }}>
//             Upload failed — check server logs
//           </div>
//         )}

//         {/* ══ BODY ═════════════════════════════════════════════════ */}
//         <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

//           {/* ── VIDEO AREA ── */}
//           <div style={{ flex: 1, position: "relative", background: "var(--bg-deep)", display: "flex", flexDirection: "column", overflow: "hidden" }}>

//             {/* CHANGED: main video area — full screen single tile */}
//             <div style={{ flex: 1, padding: 16, display: "flex", overflow: "hidden" }}>

//               {/* HOST VIEW: show own camera/screen */}
//               {isHost && (
//                 <HostVideoTile
//                   videoTrack={localVideo}
//                   screenTrack={screenTrack}
//                   screenOn={screenOn}
//                   camOn={camOn}
//                   hostName={displayName}
//                   micOn={micOn}
//                 />
//               )}

//               {/* AUDIENCE VIEW: show host's video only */}
//               {!isHost && (
//                 <div style={{ width: "100%", height: "100%", position: "relative" }}>
//                   {remoteHostUser ? (
//                     <RemoteHostTile
//                       user={remoteHostUser}
//                       hostName={
//                         // Find host name from participants
//                         Object.values(participants).find(p => p.role === "host")?.name || "Host"
//                       }
//                     />
//                   ) : (
//                     // CHANGED: waiting screen for audience when host hasn't joined
//                     <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, background: "var(--bg-deep)" }}>
//                       <div style={{ width: 64, height: 64, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                         <Icon d={icons.eye} size={26} stroke="var(--text-muted)" />
//                       </div>
//                       <span style={{ color: "var(--text-muted)", fontSize: 14 }}>Waiting for host to go live…</span>
//                     </div>
//                   )}
//                   <div className="audience-banner">
//                     <Icon d={icons.eye} size={12} stroke="var(--accent-purple)" />
//                     You are watching as {displayName}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* ── BOTTOM TOOLBAR — host controls only ── */}
//             <div style={{ padding: "16px 0 22px", display: "flex", justifyContent: "center", background: "linear-gradient(to top,var(--bg-void) 0%,transparent 100%)", flexShrink: 0 }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 20px", background: "rgba(17,19,24,.85)", backdropFilter: "blur(20px)", border: "1px solid var(--border-soft)", borderRadius: 40, boxShadow: "0 8px 40px rgba(0,0,0,.5),0 1px 0 rgba(255,255,255,.05) inset" }}>

//                 {/* CHANGED: host-only controls */}
//                 {isHost && (<>
//                   <CtrlBtn iconPath={micOn ? icons.mic : icons.micOff}
//                     tooltip={micOn ? "Mute mic" : "Unmute mic"}
//                     onClick={toggleMic}
//                     cls={micOn ? "is-on" : "is-off"} />
//                   <CtrlBtn iconPath={camOn ? icons.video : icons.videoOff}
//                     tooltip={camOn ? "Stop camera" : "Start camera"}
//                     onClick={toggleCam}
//                     cls={camOn ? "is-on" : "is-off"} />
//                   <CtrlBtn iconPath={screenOn ? icons.screenOff : icons.screen}
//                     tooltip={screenOn ? "Stop sharing" : "Share screen"}
//                     onClick={toggleScreen}
//                     cls={screenOn ? "is-on" : ""} />
//                   <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />

//                   {/* Recording: start or stop */}
//                   {/* {!recording ? (
//                     <CtrlBtn iconPath={icons.record}
//                       tooltip="Start recording"
//                       onClick={startRecording}
//                       cls="" />
//                   ) : (
//                     <CtrlBtn iconPath={icons.recStop}
//                       tooltip="Stop & upload recording"
//                       onClick={stopRecording}
//                       cls="is-rec" />
//                   )} */}
//                   <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />
//                 </>)}

//                 {/* Participants toggle — both roles */}
//                 {/* <CtrlBtn iconPath={icons.users}
//                   tooltip="Participants"
//                   onClick={() => setPanelOpen(p => !p)}
//                   cls={panelOpen ? "is-on" : ""} /> */}

//                 {/* Leave — both roles */}
//                 <CtrlBtn iconPath={icons.leave}
//                   tooltip="Leave session"
//                   onClick={handleLeave}
//                   cls="is-leave" />
//               </div>
//             </div>
//           </div>

//           {/* ── PARTICIPANTS SIDE PANEL — CHANGED: no chat tab ── */}
//           {/* {panelOpen && (
//             <div className="slide-right" style={{ width: 300, borderLeft: "1px solid var(--border-dim)", background: "var(--bg-surface)", display: "flex", flexDirection: "column", overflow: "hidden", flexShrink: 0 }}>

//               <div style={{ display: "flex", alignItems: "center", padding: "16px 16px 12px", borderBottom: "1px solid var(--border-dim)", flexShrink: 0 }}>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)" }}>Participants</div>
//                   <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2, fontFamily: "var(--font-mono)" }}>
//                     {participantList.length} in session
//                   </div>
//                 </div>
//                 <button onClick={() => setPanelOpen(false)}
//                   style={{ width: 32, height: 32, background: "none", border: "1px solid var(--border-dim)", borderRadius: 8, color: "var(--text-muted)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s" }}
//                   onMouseEnter={e => { e.currentTarget.style.background = "var(--bg-raised)"; e.currentTarget.style.color = "var(--text-primary)"; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "var(--text-muted)"; }}>
//                   <Icon d={icons.close} size={13} />
//                 </button>
//               </div>

//               <div style={{ flex: 1, overflowY: "auto", padding: "12px 14px 20px" }}>

           
//                 <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, fontWeight: 600, marginBottom: 8, paddingLeft: 4, fontFamily: "var(--font-mono)" }}>HOST</div>
//                 <div style={{ marginBottom: 16 }}>
//                   {participantList.filter(p => p.role === "host").map(p => (
//                     <PCard key={p.uid} uid={p.uid} name={p.name} role="host"
//                       videoOn={p.uid === appInfo?.uid ? (isHost && camOn) : true}
//                       audioOn={p.uid === appInfo?.uid ? (isHost && micOn) : true} />
//                   ))}
                
//                   {isHost && !participantList.find(p => p.role === "host") && (
//                     <PCard uid={appInfo?.uid} name={displayName} role="host" videoOn={camOn} audioOn={micOn} />
//                   )}
//                 </div>

               
//                 {audienceCount > 0 && (<>
//                   <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, fontWeight: 600, marginBottom: 8, paddingLeft: 4, fontFamily: "var(--font-mono)" }}>
//                     VIEWERS · {audienceCount}
//                   </div>
//                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                     {participantList.filter(p => p.role !== "host").map(p => (
//                       <PCard key={p.uid} uid={p.uid} name={p.name} role="audience" videoOn={false} audioOn={false} />
//                     ))}
//                   </div>
//                 </>)}

//                 {audienceCount === 0 && (
//                   <div style={{ textAlign: "center", padding: "24px 0", color: "var(--text-muted)", fontSize: 13 }}>
//                     No viewers yet
//                   </div>
//                 )}
//               </div>
//             </div>
//           )} */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default LiveSession;



// import { useState, useEffect, useRef, useCallback } from "react";
// import { useParams, useSearchParams, useNavigate, useLocation } from "react-router-dom";
// import AgoraRTC from "agora-rtc-sdk-ng";
// import AgoraRTM from "agora-rtm-sdk";


// // ─────────────────────────────────────────────────────────────────────────────
// // URL structure: /live/:channel_name?role=host|audience&name=DisplayName
// //
// // Architecture:
// //   - HOST: publishes camera + mic, can screen share, can record
// //   - AUDIENCE: subscribe-only, no tracks, no controls
// //   - Recording: uploads to S3 via backend API (no local download)
// //   - Chat removed entirely
// // ─────────────────────────────────────────────────────────────────────────────

// const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

// /* ─────────────────────────────────────────────────────────────────────────
//    ICONS
// ───────────────────────────────────────────────────────────────────────── */
// const Icon = ({ d, size = 20, stroke = "currentColor", fill = "none", strokeWidth = 1.6 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}
//     stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
//     <path d={d} />
//   </svg>
// );
// const icons = {
//   mic: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8",
//   micOff: "M1 1l22 22M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23M12 19v4M8 23h8",
//   video: "M23 7l-7 5 7 5V7zM1 5h15a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H1a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
//   videoOff: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22",
//   screen: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3",

//   screenOff: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3M1 1l22 22",
//   users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
//   leave: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
//   recStop: "M18 6H6v12h12V6z",
//   record: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z",
//   upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
//   wifi: "M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01",
//   eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 12m-3 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0",
//   close: "M18 6L6 18M6 6l12 12",
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    GLOBAL CSS
// ───────────────────────────────────────────────────────────────────────── */
// const GlobalStyle = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=Space+Mono:wght@400;700&display=swap');
//     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
//     :root {
//       --bg-void:#050507; --bg-deep:#0b0c10; --bg-surface:#111318; --bg-raised:#191c22; --bg-overlay:#1f232b;
//       --border-dim:rgba(255,255,255,0.05); --border-soft:rgba(255,255,255,0.09); --border-bright:rgba(255,255,255,0.22);
//       --text-primary:#f0f2f8; --text-secondary:#8a909e; --text-muted:#535868;
//       --accent-cyan:#00d4ff; --accent-green:#00e676; --accent-red:#ff3d57; --accent-purple:#b47dff;
//       --glow-cyan:0 0 20px rgba(0,212,255,0.25),0 0 60px rgba(0,212,255,0.08);
//       --glow-red:0 0 20px rgba(255,61,87,0.35),0 0 60px rgba(255,61,87,0.1);
//       --font-ui:'DM Sans',sans-serif; --font-mono:'Space Mono',monospace;
//       --ease-spring:cubic-bezier(0.34,1.56,0.64,1); --ease-smooth:cubic-bezier(0.4,0,0.2,1);
//     }
//     html,body,#root { width:100%; height:100%; overflow:hidden; }
//     body { font-family:var(--font-ui); background:var(--bg-void); color:var(--text-primary); -webkit-font-smoothing:antialiased; }
//     ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-track{background:transparent} ::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.14);border-radius:4px}
//     @keyframes fadeUp     { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
//     @keyframes pulse-ring { 0%{transform:scale(1);opacity:.7} 100%{transform:scale(1.55);opacity:0} }
//     @keyframes rec-blink  { 0%,100%{opacity:1} 50%{opacity:.3} }
//     @keyframes shimmer    { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
//     @keyframes slide-right{ from{opacity:0;transform:translateX(20px)} to{opacity:1;transform:translateX(0)} }
//     @keyframes rec-pulse  { 0%,100%{box-shadow:0 0 0 0 rgba(255,61,87,.4)} 50%{box-shadow:0 0 0 8px rgba(255,61,87,0)} }
//     @keyframes fadeIn     { from{opacity:0} to{opacity:1} }
//     .shimmer-bar { height:2px; background:linear-gradient(90deg,transparent 0%,var(--accent-cyan) 50%,transparent 100%); background-size:200% 100%; animation:shimmer 2s linear infinite; opacity:.5; }
//     .ctrl-btn { position:relative; width:50px; height:50px; border-radius:50%; border:1.5px solid var(--border-soft); background:var(--bg-raised); color:var(--text-secondary); cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .22s var(--ease-smooth); outline:none; flex-shrink:0; }
//     .ctrl-btn:hover  { background:var(--bg-overlay); border-color:var(--border-bright); color:var(--text-primary); transform:translateY(-2px); }
//     .ctrl-btn:active { transform:scale(.93) translateY(0); }
//     .ctrl-btn.is-on    { background:rgba(0,212,255,.12); border-color:rgba(0,212,255,.4); color:var(--accent-cyan); box-shadow:0 0 14px rgba(0,212,255,.18); }
//     .ctrl-btn.is-off   { background:rgba(255,61,87,.12); border-color:rgba(255,61,87,.4); color:var(--accent-red); }
//     .ctrl-btn.is-rec   { background:rgba(255,61,87,.2); border-color:rgba(255,61,87,.6); color:var(--accent-red); animation:rec-pulse 2s ease-in-out infinite; }
//     .ctrl-btn.is-leave { width:56px; height:56px; background:var(--accent-red); border-color:var(--accent-red); color:#fff; }
//     .ctrl-btn.is-leave:hover { background:#ff5569; box-shadow:var(--glow-red); transform:translateY(-2px) scale(1.05); }
//     .ctrl-btn:disabled { opacity:.35; cursor:not-allowed; transform:none !important; }
//     .ctrl-tip { position:absolute; bottom:calc(100% + 10px); left:50%; transform:translateX(-50%); background:var(--bg-overlay); border:1px solid var(--border-soft); color:var(--text-primary); font-size:11px; font-family:var(--font-ui); padding:5px 10px; border-radius:6px; white-space:nowrap; opacity:0; pointer-events:none; transition:opacity .15s; }
//     .ctrl-btn:hover .ctrl-tip { opacity:1; }
//     .p-card { display:flex; align-items:center; gap:12px; padding:10px 14px; border-radius:14px; border:1px solid var(--border-dim); background:var(--bg-raised); transition:all .2s; cursor:default; animation:fadeUp .35s both; }
//     .p-card:hover { background:var(--bg-overlay); border-color:var(--border-soft); }
//     .vid-tile { position:relative; border-radius:16px; overflow:hidden; background:#0b0c10; border:1.5px solid var(--border-soft); width:100%; height:100%; animation:fadeIn .3s both; }
//     .vid-tile.local { border-color:rgba(0,212,255,.3); }
//     .vid-tile.screen { border-color:rgba(180,125,255,.4); }
//     .name-tag { position:absolute; bottom:16px; left:16px; display:flex; align-items:center; gap:6px; background:rgba(5,5,7,.8); backdrop-filter:blur(12px); border:1px solid rgba(255,255,255,.08); padding:6px 12px 6px 10px; border-radius:24px; font-size:13px; font-weight:500; color:var(--text-primary); }
//     .muted-badge { position:absolute; top:12px; right:12px; background:rgba(255,61,87,.2); border:1px solid rgba(255,61,87,.4); border-radius:50%; width:30px; height:30px; display:flex; align-items:center; justify-content:center; }
//     .rec-dot { width:8px; height:8px; border-radius:50%; background:var(--accent-red); animation:rec-blink 1.2s ease-in-out infinite; flex-shrink:0; }
//     .slide-right { animation:slide-right .28s var(--ease-spring) both; }
//     .upload-toast { position:fixed; bottom:100px; left:50%; transform:translateX(-50%); background:rgba(0,212,255,.12); border:1px solid rgba(0,212,255,.3); color:var(--accent-cyan); font-family:var(--font-ui); font-size:13px; font-weight:500; padding:10px 20px; border-radius:24px; display:flex; align-items:center; gap:8px; backdrop-filter:blur(12px); z-index:999; animation:fadeUp .4s var(--ease-spring) both; white-space:nowrap; }
//     .audience-banner { position:absolute; bottom:16px; left:50%; transform:translateX(-50%); background:rgba(180,125,255,.12); border:1px solid rgba(180,125,255,.3); color:var(--accent-purple); font-size:12px; font-weight:500; padding:6px 16px; border-radius:20px; display:flex; align-items:center; gap:6px; white-space:nowrap; pointer-events:none; }
//     @media (max-width: 768px) {
//   .vid-tile {
//     aspect-ratio: 9 / 16;   /* better for mobile */
//   }
//     .vid-tile > div > div,
// .vid-tile > div video {
//   width: 100% !important;
//   height: 100% !important;
//   object-fit: contain !important;   /* ✅ KEY FIX */
// }
//     .vid-tile.screen > div > div,
// .vid-tile.screen > div video {

//   object-fit: contain !important;   /* ✅ no cropping ever */
//   background: black;                /* ✅ fills empty space */
// }
// }
//   `}</style>
// );

// /* ─────────────────────────────────────────────────────────────────────────
//    AVATAR
// ───────────────────────────────────────────────────────────────────────── */
// const AV_COLORS = ["#00d4ff", "#00e676", "#b47dff", "#ffab00", "#ff6b6b", "#00bcd4", "#69f0ae", "#ea80fc"];
// const Avatar = ({ uid, size = 36, name }) => {
//   const color = AV_COLORS[(Number(uid) || 0) % AV_COLORS.length];
//   const initials = name ? name.slice(0, 2).toUpperCase() : String(uid || "?").slice(-2);
//   return (
//     <div style={{ width: size, height: size, borderRadius: "50%", background: `${color}22`, border: `1.5px solid ${color}55`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color, fontFamily: "var(--font-mono)", flexShrink: 0 }}>
//       {initials}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    CTRL BUTTON
// ───────────────────────────────────────────────────────────────────────── */
// const CtrlBtn = ({ iconPath, tooltip, onClick, cls = "", size = 20, disabled = false }) => (
//   <button className={`ctrl-btn ${cls}`} onClick={onClick} disabled={disabled}>
//     <Icon d={iconPath} size={size} />
//     <span className="ctrl-tip">{tooltip}</span>
//   </button>
// );


// /* ─────────────────────────────────────────────────────────────────────────
//    HOST VIDEO TILE — full-screen, single source of truth
//    Shows screen share when active, otherwise camera
// ───────────────────────────────────────────────────────────────────────── */
// const HostVideoTile = ({ videoTrack, screenTrack, screenOn, camOn, micOn, hostName }) => {


//   const cameraRef = useRef(null);
//   const screenRef = useRef(null);

//   // Play camera track
//   useEffect(() => {
//     if (!cameraRef.current || !videoTrack) return;
//     const t = setTimeout(() => { try { videoTrack.play(cameraRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [videoTrack]);

//   // Play screen track
//   useEffect(() => {
//     if (!screenRef.current || !screenTrack) return;
//     const t = setTimeout(() => { try { screenTrack.play(screenRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [screenTrack]);

//   return (
//     <div className={`vid-tile ${screenOn ? "screen" : "local"}`} style={{ background: "var(--bg-deep)" }}>
//       {/* Camera layer — hidden during screen share */}
//       <div ref={cameraRef}
//         style={{ width: "100%", height: "100%", display: screenOn ? "none" : (camOn && videoTrack ? "block" : "none") }} />

//       {/* Screen share layer */}
//       <div ref={screenRef}
//         style={{ width: "100%", height: "100%", display: screenOn && screenTrack ? "block" : "none" }} />

//       {/* No-video placeholder */}
//       {!screenOn && (!camOn || !videoTrack) && (
//         <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-deep)", flexDirection: "column", gap: 16 }}>
//           <Avatar uid={0} size={72} name={hostName} />
//           <span style={{ fontSize: 15, color: "var(--text-secondary)", fontWeight: 500 }}>{hostName}</span>
//         </div>
//       )}

//       {/* Name tag */}
//       <div className="name-tag">
//         <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
//         {screenOn ? `${hostName} · Screen Share` : hostName}
//         <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
//       </div>

//       {/* Muted badge */}
//       {!micOn && (
//         <div className="muted-badge">
//           <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    REMOTE HOST VIDEO TILE — audience sees this
// ───────────────────────────────────────────────────────────────────────── */
// const RemoteHostTile = ({ user,hostName }) => {
//   // const location = useLocation();

//   // const hostName = location.state?.hostName;
//   const videoRef = useRef(null);
  
//   const hasVideo = !!user.videoTrack;
//   const hasAudio = !!user.audioTrack;

//   // FIX: video subscribe — play into DOM container immediately after mount/track change.
//   // Agora requires the container to be in the DOM with real dimensions when play() is called.
//   // We use videoTrack as the dep so it re-runs when Agora fires user-published for "video".
//   useEffect(() => {
//     if (!videoRef.current || !user.videoTrack) return;

//     // FIX: video subscribe — small timeout lets React flush so the div is sized in the DOM
//     const t = setTimeout(() => {
//       try {
//         user.videoTrack.play(videoRef.current);
//       } catch (e) {
//         console.error("RemoteHostTile play error:", e);
//       }
//     }, 100);

//     return () => {
//       clearTimeout(t);
//       try { user.videoTrack.stop(); } catch (_) { }
//     };
//   }, [user.videoTrack]); // re-run every time the track object changes

//   return (
//     <div className="vid-tile" style={{ background: "var(--bg-deep)" }}>
//       {/* FIX: video subscribe — container must have explicit height so Agora can size the video element */}
//       <div
//         ref={videoRef}
//         style={{
//           width: "100%",
//           height: "100%",
//           minHeight: 400,
//           display: hasVideo ? "block" : "none",
//           // FIX: Agora injects a <video> inside; ensure it fills the container
//           overflow: "hidden",
//         }}
//       />
//       {!hasVideo && (
//         <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
//           <Avatar uid={user.uid} size={72} name={hostName || "Host"} />
//           <span style={{ fontSize: 15, color: "var(--text-secondary)" }}>{hostName || "Host"}</span>
//         </div>
//       )}
//       <div className="name-tag">
//         <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
//         {hostName || `Host ${String(user.uid).slice(-3)}`}
//         <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
//       </div>
//       {!hasAudio && (
//         <div className="muted-badge">
//           <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────
//    PARTICIPANT CARD
// ───────────────────────────────────────────────────────────────────────── */
// const PCard = ({ uid, name, role, videoOn, audioOn }) => (
//   <div className="p-card">
//     <Avatar uid={uid} size={38} name={name} />
//     <div style={{ flex: 1, minWidth: 0 }}>
//       <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)", display: "flex", alignItems: "center", gap: 6 }}>
//         <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
//         {role === "host" && (
//           <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: 1, background: "rgba(0,212,255,.15)", color: "var(--accent-cyan)", border: "1px solid rgba(0,212,255,.3)", padding: "2px 6px", borderRadius: 4, flexShrink: 0 }}>HOST</span>
//         )}
//       </div>
//       <div style={{ marginTop: 3, display: "flex", gap: 8 }}>
//         <span style={{ fontSize: 11, color: audioOn ? "var(--accent-green)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//           <Icon d={audioOn ? icons.mic : icons.micOff} size={11} /> {audioOn ? "Live" : "Muted"}
//         </span>
//         {role === "host" && (
//           <span style={{ fontSize: 11, color: videoOn ? "var(--accent-cyan)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//             <Icon d={videoOn ? icons.video : icons.videoOff} size={11} /> {videoOn ? "Video" : "Off"}
//           </span>
//         )}
//         {role !== "host" && (
//           <span style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
//             <Icon d={icons.eye} size={11} /> Watching
//           </span>
//         )}
//       </div>
//     </div>
//   </div>
// );

// /* ═════════════════════════════════════════════════════════════════════════
//    UPLOAD RECORDING TO S3 via backend
//    Expects backend endpoint: POST /upload-recording/
//    with multipart/form-data: { file, channel, uid }
// ═════════════════════════════════════════════════════════════════════════ */
// // const uploadRecordingToS3 = async ({ chunks, channelName, uid, onProgress }) => {
// //   if (!chunks || chunks.length === 0) return { ok: false, error: "No recording data" };

// //   const blob = new Blob(chunks, { type: "video/webm" });
// //   const filename = `recording-${channelName}-${uid}-${Date.now()}.webm`;
// //   const formData = new FormData();
// //   formData.append("file", blob, filename);
// //   formData.append("channel", channelName);
// //   formData.append("uid", String(uid));

// //   try {
// //     onProgress?.("uploading");
// //     const res = await fetch(`${API_URL}/upload-recording/`, {
// //       method: "POST",
// //       body: formData,
// //     });
// //     if (!res.ok) {
// //       const text = await res.text();
// //       throw new Error(`Upload failed: HTTP ${res.status} — ${text}`);
// //     }
// //     const data = await res.json();
// //     onProgress?.("done");
// //     return { ok: true, url: data.url || data.s3_url || null };
// //   } catch (err) {
// //     console.error("S3 upload error:", err);
// //     onProgress?.("error");
// //     return { ok: false, error: err.message };
// //   }
// // };
// const uploadRecordingToS3 = async ({
//   chunks,
//   postId,        // ✅ ADD THIS
//   channelName,
//   uid,
//   onProgress,
// }) => {
//   if (!chunks || chunks.length === 0) {
//     return { ok: false, error: "No recording data" };
//   }

//   const blob = new Blob(chunks, { type: "video/webm" });
//   const filename = `recording-${channelName}-${uid}-${Date.now()}.webm`;

//   const formData = new FormData();
//   formData.append("file", blob, filename);

//   // ✅ VERY IMPORTANT: send post_id
//   formData.append("post_id", postId);

//   try {
//     onProgress?.("uploading");

//     const res = await fetch(`${API_URL}/upload-recording/`, {
//       method: "POST",
//       body: formData,
//     });

//     if (!res.ok) {
//       const text = await res.text();
//       throw new Error(`Upload failed: HTTP ${res.status} — ${text}`);
//     }

//     const data = await res.json();

//     console.log("UPLOAD SUCCESS:", data); // ✅ debug

//     onProgress?.("done");

//     return {
//       ok: true,
//       url: data.url || null, // backend returns this
//     };

//   } catch (err) {
//     console.error("S3 upload error:", err);
//     onProgress?.("error");

//     return {
//       ok: false,
//       error: err.message,
//     };
//   }
// };

// /* ═════════════════════════════════════════════════════════════════════════
//    MAIN — LiveSession
// ═════════════════════════════════════════════════════════════════════════ */
// const LiveSession = () => {
//   const { id: channelName } = useParams();
//   const [searchParams] = useSearchParams();
//   const location = useLocation();
//   const userName = location.state?.userName;
// const hostName = location.state?.hostName;
//   const postId = searchParams.get("post_id");
//   const streamRef = useRef(null); // single MediaStream, lives for full session
//   const navigate = useNavigate();

//   // CHANGED: read display name from query param
//   const role = searchParams.get("role") === "audience" ? "audience" : "host";
//   const displayName = searchParams.get("name") || (role === "host" ? "Host" : "Viewer");
//   const isHost = role === "host";

//   /* ── Session state ── */
//   const [appInfo, setAppInfo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState("Initializing…");
  

// const micOnInitial = location.state?.micOn ?? true;
// const camOnInitial = location.state?.camOn ?? true;

// // const audioTrack = await AgoraRTC.createMicrophoneAudioTrack({
// //   microphoneId: selectedMic,
// // });

// // const videoTrack = await AgoraRTC.createCameraVideoTrack({
// //   cameraId: selectedCam,
// // });

//   /* ── Host media controls ── */
// const [micOn, setMicOn] = useState(micOnInitial);
// const [camOn, setCamOn] = useState(camOnInitial); // if a cam was pre-selected, start with video on
//   const [screenOn, setScreenOn] = useState(false);

//   /* ── Recording state ── */
//   const [recording, setRecording] = useState(false);
//   const [recSeconds, setRecSeconds] = useState(0);
//   const [uploadState, setUploadState] = useState(null); // null | 'uploading' | 'done' | 'error'

//   /* ── Tracks ── */
//   const [localAudio, setLocalAudio] = useState(null);
//   const [localVideo, setLocalVideo] = useState(null);
//   const [screenTrack, setScreenTrack] = useState(null);

//   // CHANGED: remoteUsers now only tracks the HOST from audience perspective
//   // From host perspective we track audience count only (no video)
//   const [remoteUsers, setRemoteUsers] = useState([]);

//   // CHANGED: separate participants map { uid -> { name, role } }
//   // We use RTM presence to sync names
//   const [participants, setParticipants] = useState({});
//   const [attendanceId, setAttendanceId] = useState(null);

//   /* ── UI ── */
//   const [panelOpen, setPanelOpen] = useState(true);

//   /* ── Refs ── */
//   const rtcClientRef = useRef(null);
//   const rtmClientRef = useRef(null);
//   const initialized = useRef(false);
//   const mrRef = useRef(null);
//   const chunksRef = useRef([]);
//   const recTimerRef = useRef(null);
//   const appInfoRef = useRef(null); // keep latest appInfo accessible in cleanup
//   const localAudioRef = useRef(null);
//   const localVideoRef = useRef(null);
//   const screenTrackRef = useRef(null);

//   // Mirror state into refs so async cleanup can access latest values
//   useEffect(() => { appInfoRef.current = appInfo; }, [appInfo]);
//   useEffect(() => { localAudioRef.current = localAudio; }, [localAudio]);
//   useEffect(() => { localVideoRef.current = localVideo; }, [localVideo]);
//   useEffect(() => { screenTrackRef.current = screenTrack; }, [screenTrack]);

//   const fmtTime = (sec) => {
//   const m = Math.floor(sec / 60);
//   const s = sec % 60;
//   return `${m}:${s.toString().padStart(2, "0")}`;
// };

//   /* ─────────────────────────────────────────────────────────────────
//      TOKEN FETCH
//   ───────────────────────────────────────────────────────────────── */
//   const initSession = useCallback(async () => {
//     if (initialized.current) return;
//     initialized.current = true;
//     try {
//       setStatus("Fetching token…");
//       const uid = Math.floor(Math.random() * 9000) + 1000;
//       const res = await fetch(
//         `${API_URL}/agora-token/?channel=${channelName}&uid=${uid}&role=${role}&name=${encodeURIComponent(displayName)}`
//       );
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       if (!data.token || !data.appId) throw new Error("Missing token/appId");
//       setAppInfo({ appId: data.appId, token: data.token, uid, channel: channelName });
//       setStatus("Joining channel…");
//     } catch (err) {
//       setStatus(`Error: ${err.message}`);
//       setLoading(false);
//     }
//   }, [channelName, role, displayName]);

//   useEffect(() => {
//     if (channelName && !initialized.current) initSession();
//   }, [channelName, initSession]);

//   /* ─────────────────────────────────────────────────────────────────
//      JOIN — RTC + RTM
//   ───────────────────────────────────────────────────────────────── */
//   useEffect(() => {
//     if (!appInfo) return;
//     let isMounted = true;

//     const join = async () => {
//       try {
//         /* ── RTC ── */
//         const rtc = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
//         rtcClientRef.current = rtc;
//         await rtc.setClientRole(isHost ? "host" : "audience");

//         // CHANGED: audience should not see other audience users in video grid
//         // Track remote users; host sees nothing from audience (they have no tracks)
//         // FIX: audience subscribes to ALL remote users (the host is a remote user from audience POV)
//         // FIX: video subscribe — handle audio and video mediaType separately and play video immediately
//         rtc.on("user-published", async (user, mediaType) => {
//           // FIX: audience no publish — host skips subscribing to remote video (audience has no tracks anyway)
//           if (isHost) return;

//           await rtc.subscribe(user, mediaType);

//           // FIX: video subscribe — play audio track inline; store video track for rendering
//           if (mediaType === "audio" && user.audioTrack) {
//             user.audioTrack.play();
//           }

//           if (!isMounted) return;

//           // FIX: host detection via user-published event
//           // setParticipants(prev => ({
//           //   ...prev,
//           //   [user.uid]: {
//           //     uid: user.uid,
//           //     name: prev[user.uid]?.name || `Host`,
//           //     role: "host", // anyone who publishes in a live stream = host
//           //   },
//           // }));
//           // FIX: use real host name instead of "Host"
//           setParticipants(prev => ({
//             ...prev,
//             [user.uid]: {
//               uid: user.uid,
//               name: hostName || "Host",   // ✅ real name here
//               role: "host",
//             },
//           }));

//           setRemoteUsers(prev => {
//             const exists = prev.find(u => u.uid === user.uid);
//             const updated = {
//               uid: user.uid,
//               audioTrack: mediaType === "audio" ? user.audioTrack : (exists?.audioTrack ?? null),
//               // FIX: video subscribe — capture the videoTrack object so RemoteHostTile can play it
//               videoTrack: mediaType === "video" ? user.videoTrack : (exists?.videoTrack ?? null),
//             };
//             return exists ? prev.map(u => u.uid === user.uid ? updated : u) : [...prev, updated];
//           });
//         });

//         rtc.on("user-unpublished", (user, mediaType) => {
//           if (isHost) return;
//           setRemoteUsers(prev => prev.map(u =>
//             u.uid !== user.uid ? u : {
//               ...u,
//               audioTrack: mediaType === "audio" ? null : u.audioTrack,
//               videoTrack: mediaType === "video" ? null : u.videoTrack,
//             }
//           ));
//         });

//         // CHANGED: track all joined users for participant list
//         rtc.on("user-joined", (user) => {
//           if (!isMounted) return;
//           setParticipants(prev => ({ ...prev, [user.uid]: { uid: user.uid, name: user.uid === appInfo.uid ? hostName || "Host" : "Audience", role: "audience" } }));
//           if (!isHost) {
//             setRemoteUsers(prev => prev.find(u => u.uid === user.uid) ? prev : [...prev, { uid: user.uid, audioTrack: null, videoTrack: null }]);
//           }
//         });

//         rtc.on("user-left", (user) => {
//           if (!isMounted) return;
//           setParticipants(prev => { const n = { ...prev }; delete n[user.uid]; return n; });
//           setRemoteUsers(prev => prev.filter(u => u.uid !== user.uid));
//         });

//         await rtc.join(appInfo.appId, appInfo.channel, appInfo.token, appInfo.uid);

//         /* ── Host publishes tracks only ── */
//         if (isHost) {
//           let audio, video;

// const selectedCam = location.state?.selectedCam;
// const selectedMic = location.state?.selectedMic;

// if (selectedCam || selectedMic) {
//   audio = await AgoraRTC.createMicrophoneAudioTrack({
//     microphoneId: selectedMic,
//   });

//   video = await AgoraRTC.createCameraVideoTrack({
//     cameraId: selectedCam,
//   });
// } else {
//   [audio, video] = await AgoraRTC.createMicrophoneAndCameraTracks();
// }
// await audio.setMuted(!micOnInitial);
// await video.setMuted(!camOnInitial);
//           if (!isMounted) { audio.stop(); audio.close(); video.stop(); video.close(); return; }
//           await rtc.publish([audio, video]);
//           setLocalAudio(audio);
//           setLocalVideo(video);
//         }

//         /* ── RTM — for name sync & presence ── */
//         setStatus("Connecting to presence…");

//         // FIX: RTM constructor — agora-rtm-sdk v2 exports the class as default.
//         // { RTM } destructuring fails ("RTM is not a constructor").
//         // Support both SDK shapes: v2 default export OR v1 named export.
//         const RTMClass = AgoraRTM.RTM || AgoraRTM.default?.RTM || AgoraRTM;
//         const rtm = new RTMClass(appInfo.appId, String(appInfo.uid));
//         rtmClientRef.current = rtm;

//         await rtm.login({ token: appInfo.token });

//         // FIX: subscribe before trying to publish or setState
//         try {
//           await rtm.subscribe(appInfo.channel, { withPresence: true, withMessage: true });
//         } catch (subErr) {
//           console.warn("RTM subscribe:", subErr);
//         }

//         // FIX: listen for NAME_SYNC messages (fallback name broadcast)
//         rtm.addEventListener("message", (event) => {
//           if (!isMounted) return;
//           try {
//             const p = JSON.parse(event.message);
//             if (p.type === "NAME_SYNC" && p.uid && p.name) {
//               setParticipants(prev => ({
//                 ...prev,
//                 [p.uid]: { uid: p.uid, name: p.name, role: p.role || "audience" },
//               }));
//             }
//           } catch (_) { }
//         });

//         // Announce our presence with name + role
//         // FIX: RTM presence setState signature differs between SDK versions — try both
//         try {
//           // RTM v2 presence setState
//           if (typeof rtm.presence?.setState === "function") {
//             await rtm.presence.setState(appInfo.channel, "MESSAGE_CHANNEL", {
//               name: displayName,
//               role: role,
//             });
//           }
//         } catch (presenceErr) {
//           console.warn("RTM presence.setState:", presenceErr);
//         }

//         // FIX: also broadcast via channel message so other clients get our name immediately
//         // This is a fallback that works across all RTM SDK versions
//         try {
//           const nameMsg = JSON.stringify({ type: "NAME_SYNC", uid: appInfo.uid, name: displayName, role });
//           await rtm.publish(appInfo.channel, nameMsg);
//         } catch (_) { /* non-critical */ }

//         // Listen for presence updates to build name map
//         rtm.addEventListener("presence", (event) => {
//           if (!isMounted) return;
//           const states = event.stateChanged || {};
//           const uid = event.publisher;
//           if (uid && states.name) {
//             setParticipants(prev => ({
//               ...prev,
//               [uid]: { uid, name: states.name, role: states.role || "audience" },
//             }));
//           }
//         });

//         // CHANGED: add ourselves to participants
//         if (isMounted) {
//           setParticipants(prev => ({
//             ...prev,
//             [appInfo.uid]: { uid: appInfo.uid, name: displayName, role },
//           }));
//         }

//         if (!isMounted) return;
//         setStatus(`Live · ${channelName}`);
//         setLoading(false);
//         // ✅ MARK JOIN
// //         try {
// //           const res = await fetch(`${API_URL}/mark-join/`, { ... });
// // if (!res.ok) {
// //   const err = await res.json().catch(() => ({}));
// //   console.error("mark-join failed:", res.status, err);
// //   return; // stop here — attendance_id stays null
// // }
// // const data = await res.json();
// // setAttendanceId(data.attendance_id);
// //         } catch (err) {
// //           console.error("Attendance join error:", err);
// //         }

//       } catch (err) {
//         console.error("Join error:", err);
//         if (isMounted) {
//           setStatus(`Join failed: ${err.message}`);
//           setLoading(false);
//         }
//       }
//     };

//     join();

//     return () => {
//       isMounted = false;
//       // Cleanup handled by handleLeave / doLeave
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [appInfo]);

//   /* ─────────────────────────────────────────────────────────────────
//      FIX: auto recording — host only, once, after loading completes
//   ───────────────────────────────────────────────────────────────── */

//    const autoRecStarted = useRef(false);
//   useEffect(() => {
//     if (loading || !isHost || autoRecStarted.current) return;
//     autoRecStarted.current = true;
//     // Delay so the UI is fully rendered before browser prompts for screen share
//     const t = setTimeout(() => { startRecording(); }, 1500);
//     return () => clearTimeout(t);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, isHost]);

  
// const startRecording = useCallback(() => {
//   if (mrRef.current) return;

//   try {
//     const stream = new MediaStream();

//     // Video: camera to start
//     const videoSource = localVideoRef.current;
//     if (videoSource?.getMediaStreamTrack) {
//       stream.addTrack(videoSource.getMediaStreamTrack());
//     }

//     // Audio: always present, never swapped
//     if (localAudioRef.current?.getMediaStreamTrack) {
//       stream.addTrack(localAudioRef.current.getMediaStreamTrack());
//     }

//     if (stream.getTracks().length === 0) {
//       console.warn("[Recording] No tracks available");
//       return;
//     }

//     streamRef.current = stream; // ✅ keep reference for track swapping

//     const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
//       ? "video/webm;codecs=vp9,opus"
//       : "video/webm";

//     chunksRef.current = [];
//     const mr = new MediaRecorder(stream, {
//       mimeType,
//       videoBitsPerSecond: 2_500_000,
//     });

//     mr.ondataavailable = (e) => {
//       if (e.data?.size > 0) chunksRef.current.push(e.data);
//     };

//     mr.onstop = async () => {
//       const chunks = [...chunksRef.current];
//       chunksRef.current = [];
//       if (chunks.length === 0) return;

//       setUploadState("uploading");
//       const result = await uploadRecordingToS3({
//         chunks,
//         channelName,
//         uid: appInfoRef.current?.uid,
//         postId,
//         onProgress: setUploadState,
//       });
//       if (!result.ok) {
//         setUploadState("error");
//         setTimeout(() => setUploadState(null), 5000);
//       } else {
//         setUploadState("done");
//         setTimeout(() => setUploadState(null), 4000);
//       }
//     };

//     mr.start(1000);
//     mrRef.current = mr;
//     setRecording(true);
//     setRecSeconds(0);
//     recTimerRef.current = setInterval(() => setRecSeconds(s => s + 1), 1000);
//     console.log("[Recording] Started — single stream, tracks:", stream.getTracks().length);

//   } catch (err) {
//     console.error("[Recording] Failed to start:", err);
//   }
// }, [channelName, postId]);
 
//   // const startRecording = async () => {
//   //   if (recording) return;
//   //   try {
//   //     const stream = await navigator.mediaDevices.getDisplayMedia({
//   //       video: { displaySurface: "browser" },
//   //       audio: true,
//   //       preferCurrentTab: true,
//   //     });

//   //     chunksRef.current = [];
//   //     const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
//   //       ? "video/webm;codecs=vp9,opus"
//   //       : "video/webm";
//   //     const mr = new MediaRecorder(stream, { mimeType });

//   //     mr.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };

//   //     // CHANGED: on stop → upload to S3, NOT download
//   //     mr.onstop = async () => {
//   //       stream.getTracks().forEach(t => t.stop());
//   //       const chunks = [...chunksRef.current];
//   //       chunksRef.current = [];
//   //       if (chunks.length === 0) return;

//   //       setUploadState("uploading");
//   //       const result = await uploadRecordingToS3({
//   //         chunks,
//   //         channelName,
//   //         uid: appInfoRef.current?.uid,
//   //         postId,// ✅ send postId for backend association
//   //         onProgress: setUploadState,
//   //       });
//   //       if (!result.ok) {
//   //         console.error("Upload failed:", result.error);
//   //         setUploadState("error");
//   //         // Reset error toast after 5s
//   //         setTimeout(() => setUploadState(null), 5000);
//   //       } else {
//   //         setUploadState("done");
//   //         setTimeout(() => setUploadState(null), 4000);
//   //       }
//   //     };

//   //     mr.start(1000);
//   //     mrRef.current = mr;
//   //     setRecording(true);
//   //     setRecSeconds(0);
//   //     recTimerRef.current = setInterval(() => setRecSeconds(s => s + 1), 1000);

//   //   } catch (err) {
//   //     if (err.name === "NotAllowedError") {
//   //       console.log("User denied screen recording, retrying...");

//   //       // 🔁 Retry after 3 seconds
//   //       setTimeout(() => {
//   //         if (!mrRef.current && !recording) {
//   //           startRecording();
//   //         }
//   //       }, 3000);
//   //     } else {
//   //       console.error("Recording error:", err);
//   //     }
//   //   }
//   // };

  


//   /* ─────────────────────────────────────────────────────────────────
//      LEAVE — full cleanup
//   ───────────────────────────────────────────────────────────────── */
//   const doLeave = useCallback(async () => {
//     // CHANGED: stop recording first → triggers S3 upload
//     // ✅ MARK LEAVE
//     try {
//       if (attendanceId) {
//         await fetch(`${API_URL}/mark-leave/`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`
//           },
//           body: JSON.stringify({
//             attendance_id: attendanceId
//           })
//         });
//       }
//     } catch (err) {
//       console.error("Attendance leave error:", err);
//     }
//     if (mrRef.current && mrRef.current.state !== "inactive") {
//       clearInterval(recTimerRef.current);
//       mrRef.current.stop();
//       mrRef.current = null;
//       setRecording(false);
//     }

//     // CHANGED: properly stop and close ALL tracks before leaving
//     try {
//       const audio = localAudioRef.current;
//       const video = localVideoRef.current;
//       const screen = screenTrackRef.current;

//       if (audio) { try { audio.stop(); audio.close(); } catch (_) { } }
//       if (video) { try { video.stop(); video.close(); } catch (_) { } }
//       if (screen) { try { screen.stop(); screen.close(); } catch (_) { } }

//       localAudioRef.current = null;
//       localVideoRef.current = null;
//       screenTrackRef.current = null;
//     } catch (_) { }

//     // Leave RTC
//     try {
//       if (rtcClientRef.current) {
//         await rtcClientRef.current.leave();
//         rtcClientRef.current = null;
//       }
//     } catch (_) { }

//     // Leave RTM
//     try {
//       if (rtmClientRef.current) {
//         await rtmClientRef.current.unsubscribe(appInfoRef.current?.channel);
//         await rtmClientRef.current.logout();
//         rtmClientRef.current = null;
//       }
//     } catch (_) { }

//     // CHANGED: reset all local state
//     setLocalAudio(null);
//     setLocalVideo(null);
//     setScreenTrack(null);
//     setRemoteUsers([]);
//     setParticipants({});
//   }, []);

//   const handleLeave = async () => {
//     await doLeave();
//     navigate(-1);
//   };

//   // CHANGED: cleanup on unmount
//   useEffect(() => {
//     return () => { doLeave(); };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /* ─────────────────────────────────────────────────────────────────
//      MIC / CAM / SCREEN — host only
//   ───────────────────────────────────────────────────────────────── */
//   const toggleMic = async () => {
//     if (!isHost || !localAudio) return;
//     const next = !micOn;
//     await localAudio.setMuted(!next);
//     setMicOn(next);
//   };

//   const toggleCam = async () => {
//     if (!isHost || !localVideo) return;
//     const next = !camOn;
//     await localVideo.setMuted(!next);
//     setCamOn(next);
//   };

//   // const toggleScreen = async () => {
//   //   if (!isHost || !rtcClientRef.current) return;

//   //   if (screenOn) {
//   //     // CHANGED: stop screen share → auto fallback to camera
//   //     try {
//   //       await rtcClientRef.current.unpublish(screenTrack);
//   //       screenTrack.stop();
//   //       screenTrack.close();
//   //       setScreenTrack(null);
//   //       if (localVideo) {
//   //         await rtcClientRef.current.publish(localVideo);
//   //       }
//   //     } catch (err) { console.error("Stop screen:", err); }
//   //     setScreenOn(false);

//   //   } else {
//   //     try {
//   //       const track = await AgoraRTC.createScreenVideoTrack(
//   //         { encoderConfig: "1080p_1", optimizationMode: "detail" },
//   //         "auto"
//   //       );
//   //       if (localVideo) await rtcClientRef.current.unpublish(localVideo);
//   //       await rtcClientRef.current.publish(track);

//   //       // CHANGED: handle browser-native screen share stop (user clicks "Stop sharing")
//   //       const handleTrackEnded = () => {
//   //         // Run async cleanup without awaiting in the event handler
//   //         (async () => {
//   //           try {
//   //             if (rtcClientRef.current) await rtcClientRef.current.unpublish(track);
//   //             track.stop();
//   //             track.close();
//   //             if (localVideoRef.current && rtcClientRef.current) {
//   //               await rtcClientRef.current.publish(localVideoRef.current);
//   //             }
//   //           } catch (_) { }
//   //           setScreenTrack(null);
//   //           setScreenOn(false);
//   //         })();
//   //       };
//   //       track.on("track-ended", handleTrackEnded);

//   //       setScreenTrack(track);
//   //       setScreenOn(true);
//   //     } catch (err) {
//   //       if (err.name !== "NotAllowedError") console.error("Screen share:", err);
//   //     }
//   //   }
//   // };

//   const replaceRecordingVideoTrack = (newTrack) => {
//   const stream = streamRef.current;
//   if (!stream || !newTrack) return;

//   // remove all existing video tracks (safe)
//   stream.getVideoTracks().forEach(track => {
//     stream.removeTrack(track);
//   });

//   stream.addTrack(newTrack);

//   console.log("[Recording] Switched video track →", newTrack.label);
// };

//   const toggleScreen = async () => {
//   if (!isHost || !rtcClientRef.current) return;

//   if (screenOn) {
//     try {
//       await rtcClientRef.current.unpublish(screenTrack);
//       screenTrack.stop();
//       screenTrack.close();
//       setScreenTrack(null);
//       if (localVideo) await rtcClientRef.current.publish(localVideo);

//       // ✅ Swap recording track: screen → camera (no stop/restart)
//       replaceRecordingVideoTrack(
//    localVideoRef.current?.getMediaStreamTrack()
// );
//     } catch (err) { console.error("Stop screen:", err); }
//     setScreenOn(false);

//   } else {
//     try {
//       const track = await AgoraRTC.createScreenVideoTrack(
//         { encoderConfig: "1080p_1", optimizationMode: "detail" },
//         "auto"
//       );
//       if (localVideo) await rtcClientRef.current.unpublish(localVideo);
//       await rtcClientRef.current.publish(track);

//       // ✅ Swap recording track: camera → screen (no stop/restart)
//       replaceRecordingVideoTrack(
//   track.getMediaStreamTrack()
// );

//       const handleTrackEnded = () => {
//         (async () => {
//           try {
//             if (rtcClientRef.current) await rtcClientRef.current.unpublish(track);
//             track.stop();
//             track.close();
//             if (localVideoRef.current && rtcClientRef.current) {
//               await rtcClientRef.current.publish(localVideoRef.current);
//             }
//           } catch (_) {}

//           // ✅ Swap back on browser "Stop sharing" too
//           replaceRecordingVideoTrack(
//   localVideoRef.current?.getMediaStreamTrack()
// );

//           setScreenTrack(null);
//           setScreenOn(false);
//         })();
//       };
//       track.on("track-ended", handleTrackEnded);

//       setScreenTrack(track);
//       setScreenOn(true);
//     } catch (err) {
//       if (err.name !== "NotAllowedError") console.error("Screen share:", err);
//     }
//   }
// };

//   /* ─────────────────────────────────────────────────────────────────
//      DERIVED VALUES
//   ───────────────────────────────────────────────────────────────── */
//   const participantList = Object.values(participants);
//   const audienceCount = participantList.filter(p => p.role !== "host").length;

//   // FIX: host detection — in a live stream any remote user who publishes = host.
//   // Don't rely solely on RTM presence (slow). Take the first remote user with tracks,
//   // fallback to first remote user if no tracks yet (audio-only moment).
//   const remoteHostUser = !isHost
//     ? (remoteUsers.find(u => u.videoTrack || u.audioTrack) || remoteUsers[0] || null)
//     : null;

//   /* ─────────────────────────────────────────────────────────────────
//      LOADING SCREEN
//   ───────────────────────────────────────────────────────────────── */
//   if (loading) {
//     return (
//       <>
//         <GlobalStyle />
//         <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 32 }}>
//           <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20 }}>
//             <div style={{ width: 72, height: 72, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.3)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxShadow: "var(--glow-cyan)" }}>
//               <div style={{ position: "absolute", inset: 6, borderRadius: "50%", border: "1px solid rgba(0,212,255,.15)", animation: "pulse-ring 2s ease-out infinite" }} />
//               <Icon d={icons.video} size={28} stroke="var(--accent-cyan)" />
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <div style={{ fontSize: 22, fontWeight: 300, color: "var(--text-primary)", letterSpacing: "-0.5px" }}>Live Session</div>
//               <div style={{ fontSize: 13, color: "var(--accent-cyan)", marginTop: 4, fontFamily: "var(--font-mono)", letterSpacing: 2 }}>{channelName?.toUpperCase()}</div>
//             </div>
//           </div>
//           <div style={{ background: "var(--bg-surface)", border: "1px solid var(--border-soft)", borderRadius: "20px", padding: "24px 40px", display: "flex", flexDirection: "column", alignItems: "center", gap: 20, minWidth: 320 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--accent-cyan)", animation: "rec-blink 1.2s ease-in-out infinite" }} />
//               <span style={{ fontSize: 14, color: "var(--text-secondary)" }}>{status}</span>
//             </div>
//             <div style={{ width: "100%", height: 2, background: "var(--bg-overlay)", borderRadius: 2, overflow: "hidden" }}>
//               <div className="shimmer-bar" />
//             </div>
//             <div style={{ fontSize: 11, color: "var(--text-muted)", fontFamily: "var(--font-mono)", padding: "6px 14px", borderRadius: 6, background: "var(--bg-raised)", border: "1px solid var(--border-dim)", letterSpacing: 1 }}>
//               {isHost ? "HOST" : "AUDIENCE"} · {channelName?.toUpperCase()} · {displayName}
//             </div>
//             <button onClick={() => { initialized.current = false; setLoading(true); initSession(); }}
//               style={{ padding: "10px 28px", borderRadius: 24, background: "rgba(0,212,255,.1)", border: "1px solid rgba(0,212,255,.3)", color: "var(--accent-cyan)", fontFamily: "var(--font-ui)", fontSize: 14, fontWeight: 500, cursor: "pointer" }}>
//               Retry
//             </button>
//           </div>
//         </div>
//       </>
//     );
//   }

//   /* ─────────────────────────────────────────────────────────────────
//      MAIN UI
//   ───────────────────────────────────────────────────────────────── */
//   return (
//     <>
//       <GlobalStyle />
//       <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", flexDirection: "column", overflow: "hidden" }}>

//         {/* ══ TOP BAR ══════════════════════════════════════════════ */}
//         <header style={{ height: 58, display: "flex", alignItems: "center", padding: "0 20px", borderBottom: "1px solid var(--border-dim)", background: "rgba(5,5,7,.9)", backdropFilter: "blur(20px)", flexShrink: 0, zIndex: 100, gap: 16 }}>

//           <div style={{ display: "flex", alignItems: "center", gap: 14, flex: 1 }}>
//             <div style={{ width: 32, height: 32, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.35)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 12px rgba(0,212,255,.18)" }}>
//               <Icon d={icons.video} size={15} stroke="var(--accent-cyan)" />
//             </div>
//             <div>
//               {/* CHANGED: show channel name prominently */}
//               <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>{channelName}</div>
//               <div style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 5, marginTop: 1 }}>
//                 <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--accent-green)", display: "inline-block", boxShadow: "0 0 8px rgba(0,230,118,.6)" }} />
//                 Live
//                 {/* · {audienceCount} viewer{audienceCount !== 1 ? "s" : ""} */}
//               </div>
//             </div>
//           </div>

//           {/* CHANGED: show actual display name, not UID */}
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <Avatar uid={appInfo?.uid} size={28} name={displayName} />
//             <div>
//               <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text-primary)" }}>{displayName}</div>
//               <div style={{ fontSize: 10, color: isHost ? "var(--accent-cyan)" : "var(--accent-purple)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>{role.toUpperCase()}</div>
//             </div>
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, justifyContent: "flex-end" }}>
//             {recording && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(255,61,87,.1)", border: "1px solid rgba(255,61,87,.25)" }}>
//                 <div className="rec-dot" />
//                 <span style={{ fontSize: 11, color: "var(--accent-red)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>
//                   REC {fmtTime(recSeconds)}
//                 </span>
//               </div>
//             )}
//             {uploadState === "uploading" && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)" }}>
//                 <Icon d={icons.upload} size={12} stroke="var(--accent-cyan)" />
//                 <span style={{ fontSize: 11, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)" }}>UPLOADING</span>
//               </div>
//             )}
//             {screenOn && (
//               <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(180,125,255,.1)", border: "1px solid rgba(180,125,255,.3)" }}>
//                 <Icon d={icons.screen} size={13} stroke="var(--accent-purple)" />
//                 <span style={{ fontSize: 11, color: "var(--accent-purple)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>SHARING</span>
//               </div>
//             )}
//           </div>
//         </header>

//         <div className="shimmer-bar" />

//         {/* Upload result toasts */}
//         {uploadState === "done" && (
//           <div className="upload-toast">
//             <Icon d={icons.upload} size={14} />
//             Recording uploaded successfully
//           </div>
//         )}
//         {uploadState === "error" && (
//           <div className="upload-toast" style={{ background: "rgba(255,61,87,.12)", borderColor: "rgba(255,61,87,.3)", color: "var(--accent-red)" }}>
//             Upload failed — check server logs
//           </div>
//         )}

//         {/* ══ BODY ═════════════════════════════════════════════════ */}
//         <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

//           {/* ── VIDEO AREA ── */}
//           <div style={{ flex: 1, position: "relative", background: "var(--bg-deep)", display: "flex", flexDirection: "column", overflow: "hidden" }}>

//             {/* CHANGED: main video area — full screen single tile */}
//             <div style={{
//   flex: 1,
//   padding: 12,
//   display: "flex",
//   justifyContent: "center",   // ✅ center content
//   alignItems: "center",       // ✅ center vertically
//   overflow: "hidden",
//   minHeight: 0,               // ✅ IMPORTANT for flex shrink
// }}>

//               {/* HOST VIEW: show own camera/screen */}
//               {isHost && (
//                 <div style={{
//     width: "100%",
//     maxWidth: "1100px",   // ✅ prevents ultra-wide stretch
//     height: "100%",
//   }}>
//                 <HostVideoTile
//                   videoTrack={localVideo}
//                   screenTrack={screenTrack}
//                   screenOn={screenOn}
//                   camOn={camOn}
//                   hostName={userName}
//                   micOn={micOn}

//                 />
//                 </div>
//               )}

//               {/* AUDIENCE VIEW: show host's video only */}
//               {!isHost && (
//                 // <div style={{ width: "100%", height: "100%", position: "relative" }}>
//                 <div style={{
//   width: "100%",
//   maxWidth: "1100px",
//   height: "100%",
//   margin: "0 auto",
// }}>

//                   {remoteHostUser ? (
                    
//                     <RemoteHostTile
//                       user={remoteHostUser}
                      
//                         // Find host name from participants
// hostName={hostName}                      
//                     />
//                   ) : (
//                     // CHANGED: waiting screen for audience when host hasn't joined
//                     <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, background: "var(--bg-deep)" }}>
//                       <div style={{ width: 64, height: 64, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                         <Icon d={icons.eye} size={26} stroke="var(--text-muted)" />
//                       </div>
//                       <span style={{ color: "var(--text-muted)", fontSize: 14 }}>Waiting for host to go live…</span>
//                     </div>
//                   )}
//                   <div className="audience-banner">
//                     <Icon d={icons.eye} size={12} stroke="var(--accent-purple)" />
//                     You are watching as {userName}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* ── BOTTOM TOOLBAR — host controls only ── */}
//             <div style={{ padding: "16px 0 22px", display: "flex", justifyContent: "center", background: "linear-gradient(to top,var(--bg-void) 0%,transparent 100%)", flexShrink: 0 }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 20px", background: "rgba(17,19,24,.85)", backdropFilter: "blur(20px)", border: "1px solid var(--border-soft)", borderRadius: 40, boxShadow: "0 8px 40px rgba(0,0,0,.5),0 1px 0 rgba(255,255,255,.05) inset" }}>

//                 {/* CHANGED: host-only controls */}
//                 {isHost && (<>
//                   <CtrlBtn iconPath={micOn ? icons.mic : icons.micOff}
//                     tooltip={micOn ? "Mute mic" : "Unmute mic"}
//                     onClick={toggleMic}
//                     cls={micOn ? "is-on" : "is-off"} />
//                   <CtrlBtn iconPath={camOn ? icons.video : icons.videoOff}
//                     tooltip={camOn ? "Stop camera" : "Start camera"}
//                     onClick={toggleCam}
//                     cls={camOn ? "is-on" : "is-off"} />
//                   <CtrlBtn iconPath={screenOn ? icons.screenOff : icons.screen}
//                     tooltip={screenOn ? "Stop sharing" : "Share screen"}
//                     onClick={toggleScreen}
//                     cls={screenOn ? "is-on" : ""} />
//                   <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />

//                   {/* Recording: start or stop */}
//                   {/* {!recording ? (
//                     <CtrlBtn iconPath={icons.record}
//                       tooltip="Start recording"
//                       onClick={startRecording}
//                       cls="" />
//                   ) : (
//                     <CtrlBtn iconPath={icons.recStop}
//                       tooltip="Stop & upload recording"
//                       onClick={stopRecording}
//                       cls="is-rec" />
//                   )} */}
//                   <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />
//                 </>)}

//                 {/* Participants toggle — both roles */}
//                 {/* <CtrlBtn iconPath={icons.users}
//                   tooltip="Participants"
//                   onClick={() => setPanelOpen(p => !p)}
//                   cls={panelOpen ? "is-on" : ""} /> */}

//                 {/* Leave — both roles */}
//                 <CtrlBtn iconPath={icons.leave}
//                   tooltip="Leave session"
//                   onClick={handleLeave}
//                   cls="is-leave" />
//               </div>
//             </div>
//           </div>

//           {/* ── PARTICIPANTS SIDE PANEL — CHANGED: no chat tab ── */}
//           {/* {panelOpen && (
//             <div className="slide-right" style={{ width: 300, borderLeft: "1px solid var(--border-dim)", background: "var(--bg-surface)", display: "flex", flexDirection: "column", overflow: "hidden", flexShrink: 0 }}>

//               <div style={{ display: "flex", alignItems: "center", padding: "16px 16px 12px", borderBottom: "1px solid var(--border-dim)", flexShrink: 0 }}>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)" }}>Participants</div>
//                   <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2, fontFamily: "var(--font-mono)" }}>
//                     {participantList.length} in session
//                   </div>
//                 </div>
//                 <button onClick={() => setPanelOpen(false)}
//                   style={{ width: 32, height: 32, background: "none", border: "1px solid var(--border-dim)", borderRadius: 8, color: "var(--text-muted)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s" }}
//                   onMouseEnter={e => { e.currentTarget.style.background = "var(--bg-raised)"; e.currentTarget.style.color = "var(--text-primary)"; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "var(--text-muted)"; }}>
//                   <Icon d={icons.close} size={13} />
//                 </button>
//               </div>

//               <div style={{ flex: 1, overflowY: "auto", padding: "12px 14px 20px" }}>

           
//                 <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, fontWeight: 600, marginBottom: 8, paddingLeft: 4, fontFamily: "var(--font-mono)" }}>HOST</div>
//                 <div style={{ marginBottom: 16 }}>
//                   {participantList.filter(p => p.role === "host").map(p => (
//                     <PCard key={p.uid} uid={p.uid} name={p.name} role="host"
//                       videoOn={p.uid === appInfo?.uid ? (isHost && camOn) : true}
//                       audioOn={p.uid === appInfo?.uid ? (isHost && micOn) : true} />
//                   ))}
                
//                   {isHost && !participantList.find(p => p.role === "host") && (
//                     <PCard uid={appInfo?.uid} name={displayName} role="host" videoOn={camOn} audioOn={micOn} />
//                   )}
//                 </div>

               
//                 {audienceCount > 0 && (<>
//                   <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, fontWeight: 600, marginBottom: 8, paddingLeft: 4, fontFamily: "var(--font-mono)" }}>
//                     VIEWERS · {audienceCount}
//                   </div>
//                   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                     {participantList.filter(p => p.role !== "host").map(p => (
//                       <PCard key={p.uid} uid={p.uid} name={p.name} role="audience" videoOn={false} audioOn={false} />
//                     ))}
//                   </div>
//                 </>)}

//                 {audienceCount === 0 && (
//                   <div style={{ textAlign: "center", padding: "24px 0", color: "var(--text-muted)", fontSize: 13 }}>
//                     No viewers yet
//                   </div>
//                 )}
//               </div>
//             </div>
//           )} */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default LiveSession;


import { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import AgoraRTC from "agora-rtc-sdk-ng";
import AgoraRTM from "agora-rtm-sdk";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const Icon = ({ d, size = 20, stroke = "currentColor", fill = "none", strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}
    stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);
const icons = {
  mic: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8",
  micOff: "M1 1l22 22M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23M12 19v4M8 23h8",
  video: "M23 7l-7 5 7 5V7zM1 5h15a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H1a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
  videoOff: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22",
  screen: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3",
  screenOff: "M2 3h20a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 21h8M12 18v3M12 14V8M9 11l3-3 3 3M1 1l22 22",
  users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  leave: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  recStop: "M18 6H6v12h12V6z",
  record: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z",
  upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
  wifi: "M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01",
  eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 12m-3 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0",
  close: "M18 6L6 18M6 6l12 12",
};

const GlobalStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=Space+Mono:wght@400;700&display=swap');
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
    :root {
      --bg-void:#050507; --bg-deep:#0b0c10; --bg-surface:#111318; --bg-raised:#191c22; --bg-overlay:#1f232b;
      --border-dim:rgba(255,255,255,0.05); --border-soft:rgba(255,255,255,0.09); --border-bright:rgba(255,255,255,0.22);
      --text-primary:#f0f2f8; --text-secondary:#8a909e; --text-muted:#535868;
      --accent-cyan:#00d4ff; --accent-green:#00e676; --accent-red:#ff3d57; --accent-purple:#b47dff;
      --glow-cyan:0 0 20px rgba(0,212,255,0.25),0 0 60px rgba(0,212,255,0.08);
      --glow-red:0 0 20px rgba(255,61,87,0.35),0 0 60px rgba(255,61,87,0.1);
      --font-ui:'DM Sans',sans-serif; --font-mono:'Space Mono',monospace;
      --ease-spring:cubic-bezier(0.34,1.56,0.64,1); --ease-smooth:cubic-bezier(0.4,0,0.2,1);
    }
    html,body,#root { width:100%; height:100%; overflow:hidden; }
    body { font-family:var(--font-ui); background:var(--bg-void); color:var(--text-primary); -webkit-font-smoothing:antialiased; }
    ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-track{background:transparent} ::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.14);border-radius:4px}
    @keyframes fadeUp     { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
    @keyframes pulse-ring { 0%{transform:scale(1);opacity:.7} 100%{transform:scale(1.55);opacity:0} }
    @keyframes rec-blink  { 0%,100%{opacity:1} 50%{opacity:.3} }
    @keyframes shimmer    { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
    @keyframes slide-right{ from{opacity:0;transform:translateX(20px)} to{opacity:1;transform:translateX(0)} }
    @keyframes rec-pulse  { 0%,100%{box-shadow:0 0 0 0 rgba(255,61,87,.4)} 50%{box-shadow:0 0 0 8px rgba(255,61,87,0)} }
    @keyframes fadeIn     { from{opacity:0} to{opacity:1} }
    .shimmer-bar { height:2px; background:linear-gradient(90deg,transparent 0%,var(--accent-cyan) 50%,transparent 100%); background-size:200% 100%; animation:shimmer 2s linear infinite; opacity:.5; }
    .ctrl-btn { position:relative; width:50px; height:50px; border-radius:50%; border:1.5px solid var(--border-soft); background:var(--bg-raised); color:var(--text-secondary); cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .22s var(--ease-smooth); outline:none; flex-shrink:0; }
    .ctrl-btn:hover  { background:var(--bg-overlay); border-color:var(--border-bright); color:var(--text-primary); transform:translateY(-2px); }
    .ctrl-btn:active { transform:scale(.93) translateY(0); }
    .ctrl-btn.is-on    { background:rgba(0,212,255,.12); border-color:rgba(0,212,255,.4); color:var(--accent-cyan); box-shadow:0 0 14px rgba(0,212,255,.18); }
    .ctrl-btn.is-off   { background:rgba(255,61,87,.12); border-color:rgba(255,61,87,.4); color:var(--accent-red); }
    .ctrl-btn.is-rec   { background:rgba(255,61,87,.2); border-color:rgba(255,61,87,.6); color:var(--accent-red); animation:rec-pulse 2s ease-in-out infinite; }
    .ctrl-btn.is-leave { width:56px; height:56px; background:var(--accent-red); border-color:var(--accent-red); color:#fff; }
    .ctrl-btn.is-leave:hover { background:#ff5569; box-shadow:var(--glow-red); transform:translateY(-2px) scale(1.05); }
    .ctrl-btn:disabled { opacity:.35; cursor:not-allowed; transform:none !important; }
    .ctrl-tip { position:absolute; bottom:calc(100% + 10px); left:50%; transform:translateX(-50%); background:var(--bg-overlay); border:1px solid var(--border-soft); color:var(--text-primary); font-size:11px; font-family:var(--font-ui); padding:5px 10px; border-radius:6px; white-space:nowrap; opacity:0; pointer-events:none; transition:opacity .15s; }
    .ctrl-btn:hover .ctrl-tip { opacity:1; }
    .p-card { display:flex; align-items:center; gap:12px; padding:10px 14px; border-radius:14px; border:1px solid var(--border-dim); background:var(--bg-raised); transition:all .2s; cursor:default; animation:fadeUp .35s both; }
    .p-card:hover { background:var(--bg-overlay); border-color:var(--border-soft); }
    .vid-tile { position:relative; border-radius:16px; overflow:hidden; background:#0b0c10; border:1.5px solid var(--border-soft); width:100%; height:100%; animation:fadeIn .3s both; }
    .vid-tile.local { border-color:rgba(0,212,255,.3); }
    .vid-tile.screen { border-color:rgba(180,125,255,.4); }
    .name-tag { position:absolute; bottom:16px; left:16px; display:flex; align-items:center; gap:6px; background:rgba(5,5,7,.8); backdrop-filter:blur(12px); border:1px solid rgba(255,255,255,.08); padding:6px 12px 6px 10px; border-radius:24px; font-size:13px; font-weight:500; color:var(--text-primary); }
    .muted-badge { position:absolute; top:12px; right:12px; background:rgba(255,61,87,.2); border:1px solid rgba(255,61,87,.4); border-radius:50%; width:30px; height:30px; display:flex; align-items:center; justify-content:center; }
    .rec-dot { width:8px; height:8px; border-radius:50%; background:var(--accent-red); animation:rec-blink 1.2s ease-in-out infinite; flex-shrink:0; }
    .slide-right { animation:slide-right .28s var(--ease-spring) both; }
    .audience-banner { position:absolute; bottom:16px; left:50%; transform:translateX(-50%); background:rgba(180,125,255,.12); border:1px solid rgba(180,125,255,.3); color:var(--accent-purple); font-size:12px; font-weight:500; padding:6px 16px; border-radius:20px; display:flex; align-items:center; gap:6px; white-space:nowrap; pointer-events:none; }
    @media (max-width: 768px) {
  .vid-tile {
    aspect-ratio: 9 / 16;
  }
    .vid-tile > div > div,
.vid-tile > div video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
}
    .vid-tile.screen > div > div,
.vid-tile.screen > div video {
  object-fit: contain !important;
  background: black;
}
}
  `}</style>
);

const AV_COLORS = ["#00d4ff", "#00e676", "#b47dff", "#ffab00", "#ff6b6b", "#00bcd4", "#69f0ae", "#ea80fc"];
const Avatar = ({ uid, size = 36, name }) => {
  const color = AV_COLORS[(Number(uid) || 0) % AV_COLORS.length];
  const initials = name ? name.slice(0, 2).toUpperCase() : String(uid || "?").slice(-2);
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", background: `${color}22`, border: `1.5px solid ${color}55`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color, fontFamily: "var(--font-mono)", flexShrink: 0 }}>
      {initials}
    </div>
  );
};

const CtrlBtn = ({ iconPath, tooltip, onClick, cls = "", size = 20, disabled = false }) => (
  <button className={`ctrl-btn ${cls}`} onClick={onClick} disabled={disabled}>
    <Icon d={iconPath} size={size} />
    <span className="ctrl-tip">{tooltip}</span>
  </button>
);

// const HostVideoTile = ({ videoTrack, screenTrack, screenOn, camOn, micOn, hostName }) => {
//   const cameraRef = useRef(null);
//   const screenRef = useRef(null);

//   useEffect(() => {
//     if (!cameraRef.current || !videoTrack) return;
//     const t = setTimeout(() => { try { videoTrack.play(cameraRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [videoTrack]);

//   useEffect(() => {
//     if (!screenRef.current || !screenTrack) return;
//     const t = setTimeout(() => { try { screenTrack.play(screenRef.current); } catch (_) { } }, 50);
//     return () => clearTimeout(t);
//   }, [screenTrack]);

//   return (
//     <div className={`vid-tile ${screenOn ? "screen" : "local"}`} style={{ background: "var(--bg-deep)" }}>
//       <div ref={cameraRef}
//         style={{ width: "100%", height: "100%", display: screenOn ? "none" : (camOn && videoTrack ? "block" : "none") }} />
//       <div ref={screenRef}
//         style={{ width: "100%", height: "100%", display: screenOn && screenTrack ? "block" : "none" }} />
//       {!screenOn && (!camOn || !videoTrack) && (
//         <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-deep)", flexDirection: "column", gap: 16 }}>
//           <Avatar uid={0} size={72} name={hostName} />
//           <span style={{ fontSize: 15, color: "var(--text-secondary)", fontWeight: 500 }}>{hostName}</span>
//         </div>
//       )}
//       <div className="name-tag">
//         <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
//         {screenOn ? `${hostName} · Screen Share` : hostName}
//         <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
//       </div>
//       {!micOn && (
//         <div className="muted-badge">
//           <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
//         </div>
//       )}
//     </div>
//   );
// };

const HostVideoTile = ({ videoTrack, screenTrack, screenOn, camOn, micOn, hostName }) => {
    const cameraRef = useRef(null);
    const screenRef = useRef(null);

    useEffect(() => {
        if (!cameraRef.current || !videoTrack) return;
        const t = setTimeout(() => {
            try { videoTrack.play(cameraRef.current); } catch (_) {}
        }, 50);
        return () => clearTimeout(t);
    }, [videoTrack]);

    useEffect(() => {
        if (!screenRef.current || !screenTrack) return;
        const t = setTimeout(() => {
            try {
                screenTrack.play(screenRef.current);
                // ✅ Force contain so screen share never crops
                const vid = screenRef.current.querySelector("video");
                if (vid) {
                    vid.style.objectFit = "contain";
                    vid.style.width = "100%";
                    vid.style.height = "100%";
                    vid.style.background = "#000";
                }
            } catch (_) {}
        }, 50);
        return () => clearTimeout(t);
    }, [screenTrack]);

    return (
        <div
            className={`vid-tile ${screenOn ? "screen" : "local"}`}
            style={{
                background: "var(--bg-deep)",
                width: "100%",
                height: "100%",
                aspectRatio: "16/9",   // ✅ always 16:9
                position: "relative",
                overflow: "hidden",
            }}
        >
            <div ref={cameraRef}
                style={{
                    width: "100%", height: "100%",
                    display: screenOn ? "none" : (camOn && videoTrack ? "block" : "none")
                }}
            />
            <div ref={screenRef}
                style={{
                    width: "100%", height: "100%",
                    display: screenOn && screenTrack ? "block" : "none",
                    background: "#000",
                }}
            />
            {!screenOn && (!camOn || !videoTrack) && (
                <div style={{
                    width: "100%", height: "100%", display: "flex",
                    alignItems: "center", justifyContent: "center",
                    background: "var(--bg-deep)", flexDirection: "column", gap: 16
                }}>
                    <Avatar uid={0} size={72} name={hostName} />
                    <span style={{ fontSize: 15, color: "var(--text-secondary)", fontWeight: 500 }}>
                        {hostName}
                    </span>
                </div>
            )}
            <div className="name-tag">
                <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
                {screenOn ? `${hostName} · Screen Share` : hostName}
                <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
            </div>
            {!micOn && (
                <div className="muted-badge">
                    <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
                </div>
            )}
        </div>
    );
};

const RemoteHostTile = ({ user, hostName }) => {
  const videoRef = useRef(null);
  const hasVideo = !!user.videoTrack;
  const hasAudio = !!user.audioTrack;

  useEffect(() => {
    if (!videoRef.current || !user.videoTrack) return;
    const t = setTimeout(() => {
      try {
        user.videoTrack.play(videoRef.current);
      } catch (e) {
        console.error("RemoteHostTile play error:", e);
      }
    }, 100);
    return () => {
      clearTimeout(t);
      try { user.videoTrack.stop(); } catch (_) { }
    };
  }, [user.videoTrack]);

  return (
    <div className="vid-tile" style={{ background: "var(--bg-deep)" }}>
      <div
        ref={videoRef}
        style={{
          width: "100%",
          height: "100%",
          minHeight: 400,
          display: hasVideo ? "block" : "none",
          overflow: "hidden",
        }}
      />
      {!hasVideo && (
        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
          <Avatar uid={user.uid} size={72} name={hostName || "Host"} />
          <span style={{ fontSize: 15, color: "var(--text-secondary)" }}>{hostName || "Host"}</span>
        </div>
      )}
      <div className="name-tag">
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent-green)", flexShrink: 0 }} />
        {hostName || `Host ${String(user.uid).slice(-3)}`}
        <span style={{ fontSize: 10, marginLeft: 4, color: "var(--accent-cyan)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>HOST</span>
      </div>
      {!hasAudio && (
        <div className="muted-badge">
          <Icon d={icons.micOff} size={14} stroke="var(--accent-red)" />
        </div>
      )}
    </div>
  );
};

const PCard = ({ uid, name, role, videoOn, audioOn }) => (
  <div className="p-card">
    <Avatar uid={uid} size={38} name={name} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)", display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
        {role === "host" && (
          <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: 1, background: "rgba(0,212,255,.15)", color: "var(--accent-cyan)", border: "1px solid rgba(0,212,255,.3)", padding: "2px 6px", borderRadius: 4, flexShrink: 0 }}>HOST</span>
        )}
      </div>
      <div style={{ marginTop: 3, display: "flex", gap: 8 }}>
        <span style={{ fontSize: 11, color: audioOn ? "var(--accent-green)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
          <Icon d={audioOn ? icons.mic : icons.micOff} size={11} /> {audioOn ? "Live" : "Muted"}
        </span>
        {role === "host" && (
          <span style={{ fontSize: 11, color: videoOn ? "var(--accent-cyan)" : "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
            <Icon d={videoOn ? icons.video : icons.videoOff} size={11} /> {videoOn ? "Video" : "Off"}
          </span>
        )}
        {role !== "host" && (
          <span style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 3 }}>
            <Icon d={icons.eye} size={11} /> Watching
          </span>
        )}
      </div>
    </div>
  </div>
);

/* ═════════════════════════════════════════════════════════════════════════
   MAIN — LiveSession
═════════════════════════════════════════════════════════════════════════ */
const LiveSession = () => {
  const { id: channelName } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [showStopDialog, setShowStopDialog] = useState(false);
  const userName = location.state?.userName;
  const hostName = location.state?.hostName;
  const navigate = useNavigate();
  const postId = searchParams.get("post_id");

  const role = searchParams.get("role") === "audience" ? "audience" : "host";
  const displayName = searchParams.get("name") || (role === "host" ? "Host" : "Viewer");
  const isHost = role === "host";

  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("Initializing…");

  const micOnInitial = location.state?.micOn ?? true;
  const camOnInitial = location.state?.camOn ?? true;

  const [micOn, setMicOn] = useState(micOnInitial);
  const [camOn, setCamOn] = useState(camOnInitial);
  const [screenOn, setScreenOn] = useState(false);

  const [recording, setRecording] = useState(false);
  const [recSeconds, setRecSeconds] = useState(0);

  const [localAudio, setLocalAudio] = useState(null);
  const [localVideo, setLocalVideo] = useState(null);
  const [screenTrack, setScreenTrack] = useState(null);

  const [remoteUsers, setRemoteUsers] = useState([]);
  const [participants, setParticipants] = useState({});
  const [attendanceId, setAttendanceId] = useState(null);

  const [panelOpen, setPanelOpen] = useState(true);

  const rtcClientRef = useRef(null);
  const rtmClientRef = useRef(null);
  const initialized = useRef(false);
  const recTimerRef = useRef(null);

  const fmtTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  /* ─────────────────────────────────────────────────────────────────
     TOKEN FETCH
  ───────────────────────────────────────────────────────────────── */
  const initSession = useCallback(async () => {
    if (initialized.current) return;
    initialized.current = true;
    try {
      setStatus("Fetching token…");
      const uid = Math.floor(Math.random() * 9000) + 1000;
      const res = await fetch(
        `${API_URL}/agora-token/?channel=${channelName}&uid=${uid}&role=${role}&name=${encodeURIComponent(displayName)}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (!data.token || !data.appId) throw new Error("Missing token/appId");
      setAppInfo({ appId: data.appId, token: data.token, uid, channel: channelName });
      setStatus("Joining channel…");
    } catch (err) {
      setStatus(`Error: ${err.message}`);
      setLoading(false);
    }
  }, [channelName, role, displayName]);

  useEffect(() => {
    if (channelName && !initialized.current) initSession();
  }, [channelName, initSession]);

  /* ─────────────────────────────────────────────────────────────────
     JOIN — RTC + RTM
  ───────────────────────────────────────────────────────────────── */
  useEffect(() => {
    if (!appInfo) return;
    let isMounted = true;

    const join = async () => {
      try {
        const rtc = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
        rtcClientRef.current = rtc;
        await rtc.setClientRole(isHost ? "host" : "audience");

        rtc.on("user-published", async (user, mediaType) => {
          if (isHost) return;
          await rtc.subscribe(user, mediaType);
          if (mediaType === "audio" && user.audioTrack) {
            user.audioTrack.play();
          }
          if (!isMounted) return;
          setParticipants(prev => ({
            ...prev,
            [user.uid]: {
              uid: user.uid,
              name: hostName || "Host",
              role: "host",
            },
          }));
          setRemoteUsers(prev => {
            const exists = prev.find(u => u.uid === user.uid);
            const updated = {
              uid: user.uid,
              audioTrack: mediaType === "audio" ? user.audioTrack : (exists?.audioTrack ?? null),
              videoTrack: mediaType === "video" ? user.videoTrack : (exists?.videoTrack ?? null),
            };
            return exists ? prev.map(u => u.uid === user.uid ? updated : u) : [...prev, updated];
          });
        });

        rtc.on("user-unpublished", (user, mediaType) => {
          if (isHost) return;
          setRemoteUsers(prev => prev.map(u =>
            u.uid !== user.uid ? u : {
              ...u,
              audioTrack: mediaType === "audio" ? null : u.audioTrack,
              videoTrack: mediaType === "video" ? null : u.videoTrack,
            }
          ));
        });

        rtc.on("user-joined", (user) => {
          if (!isMounted) return;
          setParticipants(prev => ({ ...prev, [user.uid]: { uid: user.uid, name: user.uid === appInfo.uid ? hostName || "Host" : "Audience", role: "audience" } }));
          if (!isHost) {
            setRemoteUsers(prev => prev.find(u => u.uid === user.uid) ? prev : [...prev, { uid: user.uid, audioTrack: null, videoTrack: null }]);
          }
        });

        rtc.on("user-left", (user) => {
          if (!isMounted) return;
          setParticipants(prev => { const n = { ...prev }; delete n[user.uid]; return n; });
          setRemoteUsers(prev => prev.filter(u => u.uid !== user.uid));
        });

        await rtc.join(appInfo.appId, appInfo.channel, appInfo.token, appInfo.uid);

        if (isHost) {
          let audio, video;
          const selectedCam = location.state?.selectedCam;
          const selectedMic = location.state?.selectedMic;

          if (selectedCam || selectedMic) {
            audio = await AgoraRTC.createMicrophoneAudioTrack({ microphoneId: selectedMic });
            video = await AgoraRTC.createCameraVideoTrack({ cameraId: selectedCam });
          } else {
            [audio, video] = await AgoraRTC.createMicrophoneAndCameraTracks();
          }
          await audio.setMuted(!micOnInitial);
          await video.setMuted(!camOnInitial);
          if (!isMounted) { audio.stop(); audio.close(); video.stop(); video.close(); return; }
          await rtc.publish([audio, video]);
          setLocalAudio(audio);
          setLocalVideo(video);
        }

        setStatus("Connecting to presence…");
setStatus("Connecting to presence…");

        

let rtm = null;

try {
  rtm = AgoraRTM.createInstance(appInfo.appId);

  await rtm.login({
    uid: String(appInfo.uid),
    token: appInfo.token,
  });

  console.log("✅ RTM connected");

  rtmClientRef.current = rtm;

} catch (rtmErr) {
  console.error("❌ RTM init failed:", rtmErr);
  rtm = null;
  rtmClientRef.current = null;
}
        // All RTM usage is gated — RTM failure never blocks the session
        if (rtm) {
          try {
            await rtm.subscribe(appInfo.channel, { withPresence: true, withMessage: true });
          } catch (subErr) {
            console.warn("RTM subscribe:", subErr);
          }

          rtm.addEventListener("message", (event) => {
            if (!isMounted) return;
            try {
              const p = JSON.parse(event.message);
              if (p.type === "NAME_SYNC" && p.uid && p.name) {
                setParticipants(prev => ({
                  ...prev,
                  [p.uid]: { uid: p.uid, name: p.name, role: p.role || "audience" },
                }));
              }
            } catch (_) {}
          });

          try {
            if (typeof rtm.presence?.setState === "function") {
              await rtm.presence.setState(appInfo.channel, "MESSAGE_CHANNEL", {
                name: displayName,
                role,
              });
            }
          } catch (presenceErr) {
            console.warn("RTM presence.setState:", presenceErr);
          }

          try {
            const nameMsg = JSON.stringify({
              type: "NAME_SYNC",
              uid: appInfo.uid,
              name: displayName,
              role,
            });
            await rtm.publish(appInfo.channel, nameMsg);
          } catch (_) {}

          rtm.addEventListener("presence", (event) => {
            if (!isMounted) return;
            const states = event.stateChanged || {};
            const uid = event.publisher;
            if (uid && states.name) {
              setParticipants(prev => ({
                ...prev,
                [uid]: { uid, name: states.name, role: states.role || "audience" },
              }));
            }
          });
        }

        if (isMounted) {
          setParticipants(prev => ({
            ...prev,
            [appInfo.uid]: { uid: appInfo.uid, name: displayName, role },
          }));
        }

        if (!isMounted) return;
        setStatus(`Live · ${channelName}`);
        setLoading(false); 

      } catch (err) {
        console.error("Join error:", err);
        if (isMounted) {
          setStatus(`Join failed: ${err.message}`);
          setLoading(false);
        }
      }
    };

    join();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appInfo]);

  /* ─────────────────────────────────────────────────────────────────
     CLOUD RECORDING
  ───────────────────────────────────────────────────────────────── */
const [recordingData, setRecordingData] = useState(null);
const recordingDataRef = useRef(null); // always-fresh ref for async closures
const isStoppingRef = useRef(false); 
const startCloudRecording = useCallback(async () => {
  if (!appInfo?.uid) {
    console.error("❌ startCloudRecording: appInfo not ready");
    return;
  }
  try {
    console.log("▶ START RECORDING — channel:", channelName, "uid:", appInfo.uid);
    const res = await fetch(`${API_URL}/start-recording/`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
  body: JSON.stringify({ channel: channelName, uid: appInfo.uid }),
});
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    console.log("✅ Recording started:", data);
    if (!data.resourceId || !data.sid) {
      console.error("❌ Missing resourceId/sid in response:", data);
      return;
    }
    const rd = { resourceId: data.resourceId, sid: data.sid };
    setRecordingData(rd);
    recordingDataRef.current = rd; // keep ref in sync
  } catch (err) {
    console.error("❌ startCloudRecording failed:", err);
  }
}, [channelName, appInfo]);



const stopCloudRecording = useCallback(async () => {
  // ✅ Guard 1: already stopping or already stopped
  if (isStoppingRef.current) {
    console.warn("⚠️ stopCloudRecording: already in progress, ignoring");
    return;
  }

  const rd = recordingDataRef.current;
  if (!rd?.resourceId || !rd?.sid) {
    console.error("❌ stopCloudRecording: no recording data", rd);
    return;
  }

  isStoppingRef.current = true;  // lock immediately before any await

  console.log("⏹ STOP RECORDING — resourceId:", rd.resourceId, "sid:", rd.sid, "post_id:", postId);
  try {
    const res = await fetch(`${API_URL}/stop-recording/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify({
        resource_id: rd.resourceId,
        sid: rd.sid,
        post_id: postId,
        channel: channelName,
      }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    console.log("✅ Recording stopped");
    setRecordingData(null);
    recordingDataRef.current = null;
  } catch (err) {
    console.error("❌ stopCloudRecording failed:", err);
    isStoppingRef.current = false;  // only reset on error so retry is possible
  }
}, [postId, channelName]);

const handleStopRecording = async () => {
  if (isStoppingRef.current) return;  // ✅ Guard 2: block dialog button double-tap
  try {
    await stopCloudRecording();
    setRecording(false);
    clearInterval(recTimerRef.current);
    recTimerRef.current = null;
    setRecSeconds(0);
    setShowStopDialog(false);
  } catch (err) {
    console.error("Stop recording failed:", err);
  }
};

// const stopCloudRecording = useCallback(async () => {
//   const rd = recordingDataRef.current; // always fresh, never stale
//   if (!rd?.resourceId || !rd?.sid) {
//     console.error("❌ stopCloudRecording: no recording data", rd);
//     return;
//   }
//   console.log("⏹ STOP RECORDING — resourceId:", rd.resourceId, "sid:", rd.sid, "post_id:", postId);
//   try {
//     const res = await fetch(`${API_URL}/stop-recording/`, {
//   method: "POST",
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//   },
//   body: JSON.stringify({
//     resource_id: rd.resourceId,
//     sid: rd.sid,
//     post_id: postId,
//     channel: channelName
//   }),
// });
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//     console.log("✅ Recording stopped");
//     setRecordingData(null);
//     recordingDataRef.current = null;
//   } catch (err) {
//     console.error("❌ stopCloudRecording failed:", err);
//   }
// }, [postId]);

/* Auto-start recording when host joins — fires after RTC join sets loading=false */
useEffect(() => {
  if (loading || !isHost || !appInfo) return;
  const t = setTimeout(async () => {
    await startCloudRecording();
    setRecording(true);
    setRecSeconds(0);
    recTimerRef.current = setInterval(() => setRecSeconds(s => s + 1), 5000);
  }, 1500);
  return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [loading, isHost, appInfo]);

 

  /* Auto-start recording when host joins */
 

  // const handleStopRecording = async () => {
  //   try {
  //     await stopCloudRecording();
  //     setRecording(false);
  //     clearInterval(recTimerRef.current);
  //     recTimerRef.current = null;
  //     setRecSeconds(0);
  //     setShowStopDialog(false);
  //   } catch (err) {
  //     console.error("Stop recording failed:", err);
  //   }
  // };

  /* ─────────────────────────────────────────────────────────────────
     LEAVE — full cleanup
  ───────────────────────────────────────────────────────────────── */
  const doLeave = useCallback(async () => {
    try {
      if (attendanceId) {
        await fetch(`${API_URL}/mark-leave/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({ attendance_id: attendanceId }),
        });
      }
    } catch (err) {
      console.error("Attendance leave error:", err);
    }

    clearInterval(recTimerRef.current);
    recTimerRef.current = null;

    try {
      if (localAudio) { try { localAudio.stop(); localAudio.close(); } catch (_) { } }
      if (localVideo) { try { localVideo.stop(); localVideo.close(); } catch (_) { } }
      if (screenTrack) { try { screenTrack.stop(); screenTrack.close(); } catch (_) { } }
    } catch (_) { }

    try {
      if (rtcClientRef.current) {
        await rtcClientRef.current.leave();
        rtcClientRef.current = null;
      }
    } catch (_) { }

    try {
      if (rtmClientRef.current) {
        await rtmClientRef.current.unsubscribe(appInfo?.channel);
        await rtmClientRef.current.logout();
        rtmClientRef.current = null;
      }
    } catch (_) { }

    setLocalAudio(null);
    setLocalVideo(null);
    setScreenTrack(null);
    setRemoteUsers([]);
    setParticipants({});
  }, [attendanceId, localAudio, localVideo, screenTrack, appInfo]);

  const handleLeave = async () => {
    await doLeave();
    navigate(-1);
  };

  useEffect(() => {
    return () => { doLeave(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ─────────────────────────────────────────────────────────────────
     MIC / CAM / SCREEN — host only
  ───────────────────────────────────────────────────────────────── */
  const toggleMic = async () => {
    if (!isHost || !localAudio) return;
    const next = !micOn;
    await localAudio.setMuted(!next);
    setMicOn(next);
  };

  const toggleCam = async () => {
    if (!isHost || !localVideo) return;
    const next = !camOn;
    await localVideo.setMuted(!next);
    setCamOn(next);
  };

  const toggleScreen = async () => {
    if (!isHost || !rtcClientRef.current) return;

    if (screenOn) {
      try {
        await rtcClientRef.current.unpublish(screenTrack);
        screenTrack.stop();
        screenTrack.close();
        setScreenTrack(null);
        if (localVideo) await rtcClientRef.current.publish(localVideo);
      } catch (err) { console.error("Stop screen:", err); }
      setScreenOn(false);
    } else {
      try {
        const track = await AgoraRTC.createScreenVideoTrack({
    encoderConfig: {
        width: { ideal: 1920, max: 1920 },
        height: { ideal: 1080, max: 1080 },
        frameRate: { ideal: 15, max: 15 },
        bitrateMax: 2000,
    },
    optimizationMode: "detail",
}, "disable");
        if (localVideo) await rtcClientRef.current.unpublish(localVideo);
        await rtcClientRef.current.publish(track);

        const handleTrackEnded = () => {
          (async () => {
            try {
              if (rtcClientRef.current) await rtcClientRef.current.unpublish(track);
              track.stop();
              track.close();
              if (localVideo && rtcClientRef.current) {
                await rtcClientRef.current.publish(localVideo);
              }
            } catch (_) { }
            setScreenTrack(null);
            setScreenOn(false);
          })();
        };
        track.on("track-ended", handleTrackEnded);

        setScreenTrack(track);
        setScreenOn(true);
      } catch (err) {
        if (err.name !== "NotAllowedError") console.error("Screen share:", err);
      }
    }
  };

  /* ─────────────────────────────────────────────────────────────────
     DERIVED VALUES
  ───────────────────────────────────────────────────────────────── */
  const participantList = Object.values(participants);
  const audienceCount = participantList.filter(p => p.role !== "host").length;

  const remoteHostUser = !isHost
    ? (remoteUsers.find(u => u.videoTrack || u.audioTrack) || remoteUsers[0] || null)
    : null;

  /* ─────────────────────────────────────────────────────────────────
     LOADING SCREEN
  ───────────────────────────────────────────────────────────────── */
  if (loading) {
    return (
      <>
        <GlobalStyle />
        <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 32 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20 }}>
            <div style={{ width: 72, height: 72, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.3)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxShadow: "var(--glow-cyan)" }}>
              <div style={{ position: "absolute", inset: 6, borderRadius: "50%", border: "1px solid rgba(0,212,255,.15)", animation: "pulse-ring 2s ease-out infinite" }} />
              <Icon d={icons.video} size={28} stroke="var(--accent-cyan)" />
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 22, fontWeight: 300, color: "var(--text-primary)", letterSpacing: "-0.5px" }}>Live Session</div>
              <div style={{ fontSize: 13, color: "var(--accent-cyan)", marginTop: 4, fontFamily: "var(--font-mono)", letterSpacing: 2 }}>{channelName?.toUpperCase()}</div>
            </div>
          </div>
          <div style={{ background: "var(--bg-surface)", border: "1px solid var(--border-soft)", borderRadius: "20px", padding: "24px 40px", display: "flex", flexDirection: "column", alignItems: "center", gap: 20, minWidth: 320 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--accent-cyan)", animation: "rec-blink 1.2s ease-in-out infinite" }} />
              <span style={{ fontSize: 14, color: "var(--text-secondary)" }}>{status}</span>
            </div>
            <div style={{ width: "100%", height: 2, background: "var(--bg-overlay)", borderRadius: 2, overflow: "hidden" }}>
              <div className="shimmer-bar" />
            </div>
            <div style={{ fontSize: 11, color: "var(--text-muted)", fontFamily: "var(--font-mono)", padding: "6px 14px", borderRadius: 6, background: "var(--bg-raised)", border: "1px solid var(--border-dim)", letterSpacing: 1 }}>
              {isHost ? "HOST" : "AUDIENCE"} · {channelName?.toUpperCase()} · {displayName}
            </div>
            <button onClick={() => { initialized.current = false; setLoading(true); initSession(); }}
              style={{ padding: "10px 28px", borderRadius: 24, background: "rgba(0,212,255,.1)", border: "1px solid rgba(0,212,255,.3)", color: "var(--accent-cyan)", fontFamily: "var(--font-ui)", fontSize: 14, fontWeight: 500, cursor: "pointer" }}>
              Retry
            </button>
          </div>
        </div>
      </>
    );
  }

  /* ─────────────────────────────────────────────────────────────────
     MAIN UI
  ───────────────────────────────────────────────────────────────── */
  return (
    <>
      <GlobalStyle />
      <div style={{ width: "100vw", height: "100vh", background: "var(--bg-void)", display: "flex", flexDirection: "column", overflow: "hidden" }}>

        <header style={{ height: 58, display: "flex", alignItems: "center", padding: "0 20px", borderBottom: "1px solid var(--border-dim)", background: "rgba(5,5,7,.9)", backdropFilter: "blur(20px)", flexShrink: 0, zIndex: 100, gap: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, flex: 1 }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.35)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 12px rgba(0,212,255,.18)" }}>
              <Icon d={icons.video} size={15} stroke="var(--accent-cyan)" />
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>{channelName}</div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", gap: 5, marginTop: 1 }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--accent-green)", display: "inline-block", boxShadow: "0 0 8px rgba(0,230,118,.6)" }} />
                Live
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Avatar uid={appInfo?.uid} size={28} name={displayName} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: "var(--text-primary)" }}>{displayName}</div>
              <div style={{ fontSize: 10, color: isHost ? "var(--accent-cyan)" : "var(--accent-purple)", fontFamily: "var(--font-mono)", letterSpacing: 1 }}>{role.toUpperCase()}</div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, justifyContent: "flex-end" }}>
            {recording && (
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(255,61,87,.1)", border: "1px solid rgba(255,61,87,.25)" }}>
                <div className="rec-dot" />
                <span style={{ fontSize: 11, color: "var(--accent-red)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>
                  REC {fmtTime(recSeconds)}
                </span>
              </div>
            )}
            {screenOn && (
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(180,125,255,.1)", border: "1px solid rgba(180,125,255,.3)" }}>
                <Icon d={icons.screen} size={13} stroke="var(--accent-purple)" />
                <span style={{ fontSize: 11, color: "var(--accent-purple)", fontWeight: 600, letterSpacing: 1, fontFamily: "var(--font-mono)" }}>SHARING</span>
              </div>
            )}
          </div>
        </header>

        <div className="shimmer-bar" />

        <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
          <div style={{ flex: 1, position: "relative", background: "var(--bg-deep)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ flex: 1, padding: 12, display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", minHeight: 0 }}>

              {isHost && (
                <div style={{ width: "100%", maxWidth: "1100px", height: "100%" }}>
                  <HostVideoTile
                    videoTrack={localVideo}
                    screenTrack={screenTrack}
                    screenOn={screenOn}
                    camOn={camOn}
                    hostName={userName}
                    micOn={micOn}
                  />
                </div>
              )}

              {!isHost && (
                <div style={{ width: "100%", maxWidth: "1100px", height: "100%", margin: "0 auto" }}>
                  {remoteHostUser ? (
                    <RemoteHostTile user={remoteHostUser} hostName={hostName} />
                  ) : (
                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, background: "var(--bg-deep)" }}>
                      <div style={{ width: 64, height: 64, borderRadius: "50%", border: "1.5px solid rgba(0,212,255,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Icon d={icons.eye} size={26} stroke="var(--text-muted)" />
                      </div>
                      <span style={{ color: "var(--text-muted)", fontSize: 14 }}>Waiting for host to go live…</span>
                    </div>
                  )}
                  <div className="audience-banner">
                    <Icon d={icons.eye} size={12} stroke="var(--accent-purple)" />
                    You are watching as {userName}
                  </div>
                </div>
              )}
            </div>

            <div style={{ padding: "16px 0 22px", display: "flex", justifyContent: "center", background: "linear-gradient(to top,var(--bg-void) 0%,transparent 100%)", flexShrink: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 20px", background: "rgba(17,19,24,.85)", backdropFilter: "blur(20px)", border: "1px solid var(--border-soft)", borderRadius: 40, boxShadow: "0 8px 40px rgba(0,0,0,.5),0 1px 0 rgba(255,255,255,.05) inset" }}>

                {isHost && (<>
                  <CtrlBtn iconPath={micOn ? icons.mic : icons.micOff}
                    tooltip={micOn ? "Mute mic" : "Unmute mic"}
                    onClick={toggleMic}
                    cls={micOn ? "is-on" : "is-off"} />
                  <CtrlBtn iconPath={camOn ? icons.video : icons.videoOff}
                    tooltip={camOn ? "Stop camera" : "Start camera"}
                    onClick={toggleCam}
                    cls={camOn ? "is-on" : "is-off"} />
                  <CtrlBtn iconPath={screenOn ? icons.screenOff : icons.screen}
                    tooltip={screenOn ? "Stop sharing" : "Share screen"}
                    onClick={toggleScreen}
                    cls={screenOn ? "is-on" : ""} />
                  <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />
                  <div style={{ width: 1, height: 32, background: "var(--border-soft)", margin: "0 4px" }} />
                </>)}

                {isHost && recording && (
                  <CtrlBtn
                    iconPath={icons.recStop}
                    tooltip="Stop recording"
                    onClick={() => setShowStopDialog(true)}
                    cls="is-rec"
                  />
                )}

                <CtrlBtn iconPath={icons.leave}
                  tooltip="Leave session"
                  onClick={handleLeave}
                  cls="is-leave" />
              </div>
            </div>
          </div>
        </div>

        {showStopDialog && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div style={{ width: 360, background: "var(--bg-surface)", border: "1px solid var(--border-soft)", borderRadius: 16, padding: 24, textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.6)" }}>
              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 10 }}>Stop Recording?</div>
              <div style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 20 }}>
                This will permanently stop the session recording. You cannot resume it again.
              </div>
              <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                <button
                  onClick={() => setShowStopDialog(false)}
                  style={{ padding: "10px 18px", borderRadius: 8, border: "1px solid var(--border-soft)", background: "transparent", color: "var(--text-primary)", cursor: "pointer" }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleStopRecording}
                  style={{ padding: "10px 18px", borderRadius: 8, border: "none", background: "var(--accent-red)", color: "#fff", cursor: "pointer" }}
                >
                  Yes, Stop
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LiveSession;